import {
  CampaignCreatePageKey,
  CampaignListPageKey,
  CampaignListTableKey,
  CampaignReviewPageKey,
  ReferralAnalyticsKey,
  ReferralBulkActionsKey,
  ReferralReportsKey,
  ReferralRewardModeKey,
  ReferralTierLadderKey
} from '../../TModules';

export const translations = {
  [CampaignListPageKey]: {
    Title: 'Campagnes',
    Label: 'Créer une nouvelle'
  },

  [CampaignListTableKey]: {
    All: 'Tout',
    Draft: 'Brouillon',
    Pending: 'En attente',
    Scheduled: 'Programmé',
    Active: 'Actif',
    Ended: 'Terminé',
    Inactive: 'Inactif',
    SearchPlaceholder: 'Rechercher une campagne par nom, identifiant ou notes internes',
    FilterBy: 'Filtrer par',

    // Game Types
    TapWin: 'Tapez & gagnez',
    CollectWin: 'Collectez & gagnez',
    ShakeTheTree: "Secouez l'arbre",
    HitThePinata: 'Frappez la Piñata',
    SpinTheWheel: 'Tournez la roue',
    Plinko: 'Plinko',
    MysteryBox: 'Boîte mystère',
    ScratchCard: 'Carte à gratter',
    BubblePop: 'Blasenblasen',
    ClawMachine: 'Machine à griffes',

    OnDeactivateErrorMessage: 'Erreur lors de la désactivation de la campagne',
    OnApproveErrorMessage: "Erreur lors de l'approbation de la campagne",
    OnMoveRowErrorMessage: 'Erreur lors du tri de la campagne.',

    Approve: 'Approuver',
    Review: 'Examiner',
    Edit: 'Modifier',
    Activate: 'Activer',
    Deactivate: 'Désactiver',
    Duplicate: 'Dupliquer',
    UploadTries: 'Télécharger les essais',
    MoveToTop: 'Déplacer en haut',
    ApproveCampaign: 'Approuver la campagne',

    Name: 'Nom',
    Type: 'Type',
    Status: 'Statut',
    StartDate: 'Date de début',
    EndDate: 'Date de fin',
    Request: 'Demande',
    Comments: 'Commentaires',
    Actions: 'Actions',
    AllGames: 'Tous les jeux',
    ApproveRequests: 'Approuver les demandes',
    CampaignTypeNotAllowedForApproval:
      "Ce type de campagne n'est pas activé. Veuillez contacter Perx pour plus d'assistance.",
    InternalNotes: 'Notes internes',
    ApproveMultipleMessageModal: {
      MultipleApproveRequestSuccessMessage: 'Les demandes ont été approuvées',
      SuccessMessage: 'Campagnes approuvées',
      ErrorMessage: "Erreur lors de l'approbation des campagnes.",
      Title: 'Approuver plusieurs demandes ?',
      OkText: 'Approuver la sélection',
      CancelText: 'Annuler',
      DescriptionLineOne: 'Êtes-vous sûr de vouloir approuver toutes les demandes sélectionnées ?',
      DescriptionLineTwo:
        "Veuillez vérifier les détails avant d'approuver car cette action ne peut pas être annulée.",
      ErrorApprovingRewards: "Erreur lors de l'approbation des récompenses."
    },

    ApproveMessageModal: {
      SuccessMessage: 'La demande a été approuvée',
      FailureMessage: "Erreur lors de l'approbation de la campagne.",
      Title: 'Approuver la campagne ?',
      OkText: 'Approuver',
      DescriptionLineOne: 'Êtes-vous sûr de vouloir approuver cette campagne ?',
      DescriptionLineTwo: 'Cette action ne peut pas être annulée.'
    },

    CampaignType: {
      AllCampaigns: 'Toutes les campagnes',
      InstantReward: 'Récompense instantanée',
      Stamp: 'Stempel',
      Referral: 'Référence',
      Game: 'Jeu',
      Reward: 'Récompense',
      Quiz: 'Quiz',
      Survey: 'Enquête',
      Quest: 'Quest',
      Progress: 'Progression',
      Raffle: 'Tirage au sort',
      MultipleRuleCampaign: 'Campagne à règles multiples'
    }
  },

  [CampaignCreatePageKey]: {
    CreatingACampaign: "Création d'une campagne",
    CampaignCreated: 'Campagne créée',
    CampaignSubmittedForApproval: 'La campagne a été soumise pour approbation',
    FailedToCreateCampaign: 'Échec de la création de la campagne',
    DeactivatingCampaign: 'Désactivation de la campagne...',
    CampaignDeactivationRequestSubmittedForApproval:
      'La demande de désactivation de la campagne a été soumise pour approbation !',
    DeactivatingSuccess: 'Désactivation réussie...',
    FailedToDeactivate: 'Échec de la désactivation !',

    ActivatingCampaign: 'Activation de la campagne...',
    CampaignActivationRequestSubmittedForApproval:
      "La demande d'activation de la campagne a été soumise pour approbation !",
    ActivatingSuccess: 'Activation réussie...',
    FailedToActivate: "Échec de l'activation !",
    UpdatingCampaign: 'Mise à jour de la campagne',
    CampaignUpdateRequestSubmittedForApproval: 'La campagne a été soumise pour approbation !',
    FailedToUpdate: 'Erreur lors de la mise à jour de la campagne !',

    FailedToLoadData: 'Échec du chargement des données !',
    FailedToOrderCampaign: 'Échec du tri de la campagne !',

    DuplicatingCampaign: 'Duplication de la campagne...',
    OnSubmitErrorMessage: 'Aucune modification détectée',

    RequiredErrorMessage: 'Le nom de la campagne est requis',
    UploadedImagesShouldBeSetAsASection:
      'Les images téléchargées doivent être définies comme une section',
    PromoteUntilMustBeAfterStartDate:
      'La date de promotion doit être postérieure à la date de début',
    PromoteUntilMustBeBeforeEndDate: 'La date de promotion doit être antérieure à la date de fin',
    PromoteUntilMustBeBetweenStartAndEndDate:
      'La date de promotion doit être comprise entre la date de début et la date de fin',
    PleaseSelectAnOwner: 'Veuillez sélectionner un propriétaire',
    PleaseAddAtLeast2Outcomes: 'Veuillez ajouter au moins 2 résultats',
    EndDateCannotBeEarlierThanStartDate:
      'La date de fin doit être égale ou postérieure à la date de début',
    PrizeSetMustIncludeAtLeastOnePrizeForSlotNumber:
      "L'ensemble de prix doit inclure au moins un prix pour l'emplacement numéro {{position}}",
    PleaseAddAPrizeTitleForSlotNumber:
      "Veuillez ajouter un titre de prix pour l'emplacement numéro {{position}}",
    PleaseAddAtLeast2OutcomesForSlotNumber:
      "Veuillez ajouter au moins 2 résultats pour l'emplacement numéro {{position}}",
    PrizeSetMustIncludeAtLeastOnePrize: "L'ensemble de prix doit inclure au moins un prix",
    RandomOutcomeSetMustIncludeAtLeastOneOutcome:
      "L'ensemble de résultats aléatoires {{index}} doit inclure au moins un résultat",
    RandomOutcomeSetMustIncludeAtLeastTwoOutcomes:
      "L'ensemble de résultats aléatoires {{index}} doit inclure au moins 2 résultats",
    TotalProbabilityOfRandomOutcomeSet:
      "La probabilité totale de l'ensemble de résultats aléatoires {{index}} doit être de 100 %",
    HeadlineHasToBeSet: 'Le titre doit être défini',
    SubHeadlineHasToBeSet: 'Le sous-titre doit être défini',
    RewardMustBePlacedOnAtLeastOneWedge: 'La récompense doit être placée sur au moins une case',
    AtLeast1WedgeMustRemainEmptyIfNoOutcomeIsSelected:
      'Au moins une case doit rester vide si "Aucun résultat" est sélectionné',
    EachOutcomeMustHaveADuplicateScore:
      'Chaque résultat doit avoir un score unique. Doublons trouvés : {{duplicateList}}',
    ScoreMustBeGraterThanZero: 'Le score doit être supérieur à 0.',
    AtLeastOneBubbleMustBeConfigured: 'Au moins une bulle doit être configurée',
    ColorHasToBeSet: 'La couleur doit être définie',
    PointHasToBeSet: 'Le point doit être défini',
    SVGCodeIsRequired: "Le code SVG est requis lorsqu'une image personnalisée est sélectionnée.",
    TargetTypeMustBeSelected: 'Le type de cible doit être sélectionné.',
    BubbleSpawnRateMustBeSelected: "Le taux d'apparition des bulles doit être sélectionné.",
    MaxBubblesMustBePositive: 'Le nombre max. de bulles doit être un nombre positif.',
    SpawnIntervalMustBeAtLeast100ms:
      "L'intervalle d'apparition doit être d'au moins 100 millisecondes.",
    BubbleLifetimeMustBeAtLeast500ms:
      "La durée de vie des bulles doit être d'au moins 500 millisecondes.",
    BubblesPerSpawnMustBePositive: 'Les bulles par apparition doivent être un nombre positif.',
    BubblesPerSpawnMustNotExceedMaxBubbles:
      'Les bulles par apparition ne doivent pas dépasser le nombre max. de bulles.',
    GameDurationMinimum10Seconds: "La durée du jeu doit être d'au moins 10 secondes.",
    MaximumOf5BubblesCanBeMarkedAsBonus:
      'Un maximum de 5 bulles peuvent être marquées comme bonus.',
    BonusImageOccurrenceMustBeBetween1And6: "L'occurrence de l'image bonus doit être entre 1 et 6.",
    PrizeModeHasToBeSelected: 'Le mode de prix doit être sélectionné.',
    ArmAccuracyMustBeAWholeNumberBetween0And100:
      'La précision du bras doit être un nombre entier entre 0 et 100.',
    FixedPrizeModeNeedsAtLeastOnePrize: 'Le mode de prix fixe nécessite au moins 1 prix.',
    RandomPrizeModeNeedsAtLeastTwoPrizes: 'Le mode de prix aléatoire nécessite au moins 2 prix.',
    NoPrizeIsOnlyAvailableInRandomPrizeMode:
      '« Inclure aucun prix comme résultat » est disponible uniquement en mode de prix aléatoire.',
    EveryPrizeNeedsASlotInFixedPrizeMode:
      'Chaque prix nécessite un emplacement en mode de prix fixe.',
    PrizeSlotsMustNotRepeat: 'Les emplacements de prix ne doivent pas se répéter.',
    EveryPrizeNeedsAnIconInFixedPrizeMode: 'Chaque prix nécessite une icône en mode de prix fixe.',
    PrizeIconsMustNotRepeatTheSameImage: 'Chaque icône de prix doit utiliser une image différente.',
    EveryPrizeIconMustMatchItsPrizeSlot:
      'Chaque icône de prix doit correspondre à son emplacement de prix.',
    EveryPrizeNeedsAProbabilityInRandomPrizeMode:
      'Chaque prix nécessite une probabilité en mode de prix aléatoire.',
    ProbabilityCannotBeNegative: 'La probabilité ne peut pas être négative.',
    ProbabilityTakesAtMost6DecimalPlaces: 'La probabilité accepte au maximum 6 décimales.',
    ClawMachineDoesNotSupportThisOutcomeType:
      'Les prix de la machine à griffes ne peuvent être que des récompenses, des points, des badges, des ensembles de prix ou aucun prix.',
    YouNeedToAddAtLeastOneQuestionToThe:
      'Vous devez ajouter au moins une question au {{campaignType}}.',
    EnglishTextForTheQuestionIsRequired:
      'Le texte anglais pour la question #{{questionNumber}} est requis',
    EnglishTextForTheChoiceIsRequired:
      'Le texte anglais pour le choix #{{choiceNumber}} de la question #{{questionNumber}} est requis',
    YouNeedToAddAtLeastOneTask: 'Vous devez ajouter au moins une tâche',
    YouNeedToSpecifyARuleForTheTask: 'Vous devez spécifier une règle pour la tâche #{{taskNumber}}',
    CampaignDurationIsRequired: 'La durée de la campagne est requise',
    CampaignDurationMustBeGreaterThanZero: 'La durée de la campagne doit être supérieure à 0',
    BodyHasToBeSetForQuestDisplaySetup:
      "Le corps doit être défini pour la configuration de l'affichage de la quête",
    YouNeedToSpecifyTheTeamSize: "Vous devez spécifier la taille de l'équipe",
    TeamSizeMustBePositive: "La taille de l'équipe doit être positive",
    EnglishHeadlineCannotBeEmpty: 'Le titre anglais ne peut pas être vide',
    LevelTabNameCannotBeEmpty: 'Le nom de l\'onglet "Niveau" ne peut pas être vide',
    CampaignPointsShortFormCannotBeEmpty:
      "L'abréviation des points de campagne ne peut pas être vide",
    YouNeedToSpecifyACampaignPointsForTheLevel:
      'Vous devez spécifier des points de campagne pour le niveau #{{levelNumber}}',
    YouNeedToSpecifyAnIssuePrizeDescriptionForTheLevel:
      'Vous devez spécifier une description de "remise de prix" pour le niveau #{{levelNumber}}',
    LevelPointsMustBeMoreThanLevelPoints:
      'Les points du niveau {{levelNumber}} doivent être supérieurs à ceux du niveau {{errorIndex}} !',
    YouNeedToAddAtLeast2OutcomesForTheLevel:
      'Vous devez ajouter au moins 2 résultats pour le niveau #{{levelNumber}}',
    PrizeSetRequiresAPrizeTitleForTheLevel:
      "L'ensemble de prix nécessite un titre de prix pour le niveau #{{levelNumber}}",
    YouNeedToAddAtLeastOneOutcomeForTheRandomizedOutcomeSet:
      "Vous devez ajouter au moins un résultat pour l'ensemble de résultats aléatoires {{randomOutcomeIndex}} dans le niveau #{{levelNumber}}",
    TheProbabilitiesOfTheOutcomesInRandomizedOutcomeSet:
      "Les probabilités des résultats dans l'ensemble de résultats aléatoires {{randomOutcomeIndex}} du niveau #{{levelNumber}} doivent totaliser 100 %",
    EachOutcomeProbabilityInRandomizedOutcomeSetMustBeGreaterThanZero:
      "La probabilité de chaque résultat dans l'ensemble de résultats aléatoires {{randomOutcomeIndex}} du niveau #{{levelNumber}} doit être supérieure à 0 %",
    HowToParticipateTabNameCannotBeEmpty:
      'Le nom de l\'onglet "Comment participer" ne peut pas être vide',
    HowToParticipateBodyTextCannotBeEmpty:
      'Le texte du corps "Comment participer" ne peut pas être vide',
    NumbersHaveToBeLessThan: 'Les nombres doivent être inférieurs à {{maxValue}} !',
    OperatingClosesTimeShouldBeGreaterThanOperatingOpensTime:
      "L'heure de fermeture doit être supérieure à l'heure d'ouverture",
    OperatingOpensTimeShouldBeEarlierThanOperatingClosesTime:
      "L'heure d'ouverture doit être antérieure à l'heure de fermeture",
    DaysCannotBeEmptyPleaseSelectValidDays:
      'Les jours ne peuvent pas être vides. Veuillez sélectionner des jours valides',
    TimesCannotBeEmptyPleaseSelectValidTimes:
      'Les horaires ne peuvent pas être vides. Veuillez sélectionner des horaires valides',
    ProbabilityMustAlwaysAddUpTo100: 'La probabilité doit toujours être égale à 100 %',
    ProbabilityShouldBeGreaterThan0: 'La probabilité doit être supérieure à 0 %',
    OutcomesCannotBeEmpty: 'Les résultats ne peuvent pas être vides.',
    PleaseAddOutcomesToWedges: 'Veuillez ajouter des résultats aux sections : {{wedges}}',
    EndDateCannotBeEmpty: 'La date de fin ne peut pas être vide.',
    AddAtLeastOneRule: 'Ajoutez au moins une règle',
    AddAtLeastOnePrizeSet: 'Ajoutez au moins un ensemble de prix',
    AddAtLeastOneOutcomeToThePrizeSet: "Ajoutez au moins un résultat à l'ensemble de prix",
    PleaseUploadTheFile: 'Veuillez télécharger le fichier',
    CampaignRequestUpdated: 'Campagne demande mise à jour',
    CampaignIsSubmittedForApproval: 'Campagne soumise pour approbation',
    CampaignUpdated: 'Campagne mise à jour',
    IncompleteAudienceFilters:
      'Veuillez compléter ou supprimer ces filtres d’audience avant de continuer : {{filters}}.',
    LimitTo: 'Limiter à',
    SelectTaskTypeIsRequired: 'Le type de tâche est requis',
    StreakModeIsRequired: 'Le mode série est requis',
    AmountSpendIsRequired: 'Le montant dépensé est requis',
    AmountSpendMustBeGreaterThanZero: 'Le montant dépensé doit être supérieur à zéro',
    StreakTargetIsRequired: 'L’objectif de série est requis',
    StreakTargetMustBeGreaterThanZero: 'L’objectif de série doit être supérieur à zéro',
    StreakTargetCriteriaIsRequired: 'Les critères de l’objectif de série sont requis',
    StreakTargetCriteriaMustBeGreaterThanZero:
      'Les critères de l’objectif de série doivent être supérieurs à zéro',
    StreakDurationIsRequired: 'La durée de la série est requise',
    MilestonesAndPrizesAreRequired: 'Les étapes et les prix sont requis',
    AtLeastOneOutcomeIsRequiredForMilestonesAndPrizes:
      'Au moins un résultat est requis pour les étapes et les prix',
    AtLeastOneConditionIsRequired: 'Au moins une condition est requise',
    InvalidCondition: 'Condition invalide',
    SelectTriggerFieldIsRequired: 'Le champ de déclencheur est requis',
    OperatorFieldIsRequired: 'Le champ opérateur est requis',
    ValueIsRequired: 'La valeur est requise',

    Steps: {
      Back: 'Retour',
      Cancel: 'Annuler',
      Next: 'Suivant',
      SaveAsDraft: 'Enregistrer comme brouillon',
      Publish: 'Publier',
      Save: 'Enregistrer',
      Deactivate: 'Désactiver',
      Schedule: 'Planifier',
      StreakMode: 'Mode série',
      TaskType: 'Type de tâche',
      StreakTargetAndPrizes: 'Objectif de série et prix',

      Info: 'Info',
      SelectAudience: "Sélectionner l'audience",
      Mechanics: 'Mécaniques',
      Review: 'Révision',
      DetailedTitle: {
        Info: 'Informations de la campagne',
        SelectAudience: "Sélectionner l'audience",
        Mechanics: 'Mécaniques',
        Review: 'Révision'
      },
      ViewInsights: 'Afficher les insights',
      Edit: 'Modifier',
      Loading: 'Chargement'
    },

    CampaignInfo: {
      Title: 'Détails de la campagne',
      Form: {
        Name: 'Nom',
        NamePlaceholder: 'Veuillez saisir le nom de votre campagne',
        ContentSuggestions: 'Suggestions de contenu',
        ShowChatGPTForm: {
          TooltipTitle:
            'Les limites de jetons se renouvellent quotidiennement. Devenez membre exclusif Perx pour des jetons illimités',
          TokensLeft: 'jetons restants'
        },
        Description: 'Description',
        TermsAndConditions: 'Conditions générales',
        RiskDisclaimer: 'Avertissement sur les risques',
        InternalNotesNotVisibleToCustomers: 'Notes internes (non visibles par les clients)',
        InternalNotesNotVisibleToCustomersPlaceholder:
          "Saisissez des notes facultatives à usage interne uniquement. Ce texte n'est pas visible par les clients.",
        MaxCharacters: 'Max {{count}} caractères.',
        CampaignDuration: 'Durée de la campagne',
        StartDate: 'Date de début',
        EndDate: 'Date de fin',
        EarlyDisplayCampaign: 'Commencer à afficher la campagne',
        DaysBeforeStartDate: 'jours avant la date de début',
        DaysBeforeTheStartDate: 'jours avant la date de début',
        CampaignDoesNotEnd: 'La campagne ne se termine pas',
        ShouldHideDurationEndDateAlertMessage:
          'Les campagnes de tirage au sort nécessitent une date de fin',
        EndDateAlertMessage: 'La date de fin doit être égale ou postérieure à la date de début',

        Reset: 'Réinitialiser',
        OCBCDemo: {
          Never: 'Jamais',
          Weekly: 'Hebdomadaire',
          Monthly: 'Mensuel',
          Yearly: 'Annuel'
        },

        ActiveAt: 'Actif à',
        ActiveAtMessage: "La campagne ne s'active pas avant la date de début",

        Tags: 'Tags',
        Categories: 'Catégories',
        Labels: 'Étiquettes',
        Catalogues: 'Catalogues',
        Owner: 'Propriétaire',
        PleaseSelectAnOwner: 'Veuillez sélectionner un propriétaire',

        UploadPhoto: 'Télécharger une photo',
        UploadMultipleImages: 'Télécharger plusieurs images',
        Merchant: 'Marchand',
        MerchantSelectPlaceholder: 'Veuillez sélectionner un marchand',
        Locations: 'Lieux',
        LocationsSelectPlaceholder: 'Veuillez sélectionner des lieux',
        CustomFields: 'Champs personnalisés',
        CustomField: 'Champ personnalisé',
        CustomFieldNamePlaceholder: 'Veuillez saisir le nom du champ',
        CustomFieldValuePlaceholder: 'Veuillez saisir la valeur du champ',
        AddCustomField: 'Ajouter un champ personnalisé'
      },

      TagSelect: 'Veuillez sélectionner vos tags',
      CategorySelect: 'Veuillez sélectionner vos catégories',
      LabelSelect: 'Veuillez sélectionner vos étiquettes',
      CatalogueSelect: 'Veuillez sélectionner vos catalogues'
    },

    ButtonWithImageUpload: {
      Cancel: 'Annuler',
      InsertPhoto: 'Insérer une photo',
      UploadFile: 'Télécharger un fichier',
      ChooseFile: 'Choisir un fichier',
      ChooseAFile: 'Choisir un fichier',
      SelectPngSvgJpegGif: 'Sélectionner PNG, SVG, JPEG ou GIF'
    },

    CampaignSelectAudience: {
      SelectAudience: 'Sélectionner une audience',
      DefaultAudience: 'Créer une audience à usage unique pour cette campagne',
      ExistingAudience: 'Sélectionner une audience existante',
      AudienceSetup: "Paramètres de l'audience",
      SelectFilters: 'Sélectionner des filtres',
      SelectedFilters: 'Filtres sélectionnés',

      AudienceListSetup: {
        Include: 'Inclure',
        Exclude: 'Exclure',
        AudienceExistsMessage: `Ne peut pas {{audienceIncludeExclude}} audience qui est déjà définie pour {{audienceIncludeExcludeNoun}}`,
        PickAudienceList: "Choisir une liste d'audience",

        Includes: 'Inclus',
        Excludes: 'Exclus',
        AudienceWarningMessage:
          "Le fichier de l'audience téléchargé ne sera traité que lorsqu'il aura été approuvé par un approbateur d'actions en bloc",
        SelectedFileForInclusion: "Fichier sélectionné pour l'inclusion",
        AudienceNotInTheList: 'Audience non dans la liste',
        IncludeAudienceFilenamePlaceholder: "Nom de la liste d'inclusion d'audience",
        UploadNow: 'Télécharger maintenant',
        UploadNewList: 'Télécharger une nouvelle liste',
        AcceptedFormat: 'Format accepté: fichiers .xlsx/.csv uniquement.',
        DownloadSample: 'Télécharger un exemple',
        UploadExclusion: "Télécharger l'exclusion",
        SelectedFileForExclusion: "Fichier sélectionné pour l'exclusion",
        ExcludeAudienceFilenamePlaceholder: "Nom de la liste d'exclusion d'audience"
      },

      AudienceFilters: {
        Age: 'Âge',
        BirthMonth: 'Mois de naissance',
        Gender: 'Sexe',
        Location: 'Localisation',
        Loyalty: 'Fidélité',
        Personal: 'Personnel',
        Custom: 'Personnalisé',
        EmailTags: 'Tags email',
        Ethnicity: 'Ethnie',
        SelectCustomerAttributeFilters: 'Sélectionner vos filtres de client',
        NoFiltersSelected: 'Aucun filtre sélectionné',

        And: 'et',
        Badge: 'Badge',
        Campaign: 'Campagne',
        Leaderboard: 'Classement',
        LoyaltyPoints: 'Points de fidélité',
        LoyaltyTier: 'Niveau de fidélité',
        MemberSince: 'Membre depuis',
        Reward: 'Récompense',
        PaymentBased: 'Basé sur le paiement',
        Payment: 'Paiement',
        SelectFilters: "Sélectionner des filtres pour générer automatiquement une liste d'audience",
        City: 'Ville',
        States: 'États',

        OfferId: "ID de l'offre",
        PrimaryClusterComb: 'Combinaison de cluster primaire',
        PrimaryClusterState: 'État du cluster primaire',
        Membership: 'Membre de',
        CurrentBirthday: 'Uniquement le jour de naissance',
        CurrentBirthMonth: 'Uniquement pendant le mois de naissance',
        HasBirthday: "Jour d'anniversaire",
        UserType: "Type d'utilisateur",
        AccountConfirmedAt: 'Inscrit entre',
        LoyaltyPointsBalance: 'Solde de points',
        CampaignEnrolment: 'Campagne',
        LeaderboardPosition: 'Position au classement',
        UPI: 'UPI',
        ScanPay: 'Paiement par scan',
        BBPS: 'BBPS',
        KYC: 'KYC',
        CurrentAddress: 'Adresse actuelle',
        PaymentStatus: 'Statut du paiement',
        DaysPastDues: 'Jours de retard',
        BNPLUnpaidEMIDate: 'Date EMI impayée BNPL',
        InstaloanUnpaidEMIDate: 'Date EMI impayée Instaloan',

        AgeFilter: {
          Title: 'Âge',
          Includes: 'Inclus',
          Excludes: 'Exclus',
          SelectPlaceholder: 'Inclus',
          From: 'âges de',
          FromPlaceholder: '18',
          To: 'à',
          ToPlaceholder: '35',
          AddRange: 'Ajouter une plage',
          And: 'et',
          from: 'de'
        },
        BirthdayFilter: {
          Title: 'Anniversaire',
          SelectBirthMonth: 'Sélectionner le mois de naissance',
          BirthMonth: 'Mois de naissance',
          CurrentBirthMonth: 'Mois de naissance actuel',
          OnlyDuringMonthOfBirth: 'Uniquement pendant le mois de naissance',
          HasBirthday: 'A son anniversaire',
          OnBirthday: 'Le jour de son anniversaire',
          Includes: 'Inclus',
          Excludes: 'Exclus'
        },
        GenderFilter: {
          Title: 'Genre',
          SelectByGender: 'Sélectionner par genre',
          Male: 'Homme',
          Female: 'Femme'
        },
        EthnicityFilter: {
          Title: 'Ethnicité',
          SelectEthnicity: "Sélectionner l'ethnicité",
          SelectEthnicityPlaceholder: "Sélectionner l'ethnicité",
          Include: 'Inclure',
          Exclude: 'Exclure',
          Includes: 'Inclus',
          Excludes: 'Exclus'
        },
        LocationFilter: {
          Title: 'Localisation',
          SelectCity: 'Sélectionner la ville',
          Include: 'Inclure',
          Exclude: 'Exclure',
          SelectCityPlaceholder: 'Sélectionner les villes',
          SelectState: "Sélectionner l'état",
          SelectStatePlaceholder: "Sélectionner l'état",
          Includes: 'Inclus',
          Excludes: 'Exclus'
        },

        PersonalFilter: {
          Title: 'Personnel',
          HubClub: 'Hub Club',
          Select: 'Sélectionner',
          Include: 'Inclure',
          Exclude: 'Exclure',
          AddCustomProperties: 'Ajouter des propriétés personnalisées',
          EnterKeyNameAndValueDetails: 'Entrer le nom de la clé et les détails de la valeur',
          SelectRelation: 'Sélectionner la relation',
          EnterNumber: 'Entrer un nombre',
          KeyValue: 'Valeur de la clé',
          DatePlaceholder: 'JJ-MM-AAAA',
          KeyNamePlaceholder: 'Nom de la clé',
          Is: 'Est',
          True: 'Vrai',
          False: 'Faux',
          And: 'ET',
          Or: 'OU',
          CustomAttributeType: 'Type de champ personnalisé #{{index}}',
          CustomAttribute: 'Champ personnalisé #{{index}}',
          CustomAttributeOperator: 'Opérateur de champ personnalisé #{{index}}',
          CustomAttributeValue: 'Valeur du champ personnalisé #{{index}}'
        },

        LoyaltyFilter: {
          Title: 'Fidélité',
          SelectLoyaltyProgram: 'Sélectionner le programme de fidélité',
          Include: 'Inclure',
          Exclude: 'Exclure',
          SelectProgram: 'Sélectionner le programme',
          Includes: 'Inclus',
          Excludes: 'Exclus',
          UsersWithPointsBalance: 'Utilisateurs avec solde de points',
          SelectLoyaltyProgramPlaceholder: 'Sélectionner le programme de fidélité',
          From: 'De',
          To: 'À',
          PointsBalanceFrom: 'Solde de points de',
          PointsBalanceTo: 'à'
        },

        EmailTagsFilter: {
          Includes: 'Inclut',
          SelectEmailTags: 'Sélectionner les tags email',
          Excludes: 'Exclut'
        }
      }
    },

    SocialMediaFields: {
      Title: 'Réseaux sociaux',
      OGTitle: 'Titre',
      OGDescription: 'Description',
      OGImage: 'Image',
      OGImageAlt: 'Aperçu réseaux sociaux',
      IOSAppLink: 'Lien App iOS',
      AndroidAppLink: 'Lien App Android',
      WebLink: 'Lien Web',

      EitherAnIOSOrAndroidOrWebLinkIsRequired: 'Un lien iOS, Android ou Web est requis',
      Allowed: 'Format accepté: .jpg, .png, .svg',
      Browse: 'Parcourir',
      Recommended: 'Recommandé: 720px par 120px',
      TitleIsRequired: 'Le titre est requis.'
    },

    CampaignMechanics: {
      CampaignType: 'Type de campagne',
      InstantReward: 'Récompense instantanée',
      MultipleRuleCampaign: 'Campagne à règles multiples',
      Reward: 'Récompense',
      Progress: 'Progression',
      Raffle: 'Tirage au sort',
      Stamp: 'Tampon',
      Game: 'Jeu',
      Quest: 'Quête',
      Referral: 'Parrainage',
      Survey: 'Sondage',
      Quiz: 'Quiz',
      Streak: 'Série',
      GiveRewardTitle: 'Émission instantanée de toutes les récompenses',
      Yes: 'Oui',
      No: 'Non',

      OutcomeType: 'Type de résultat',
      FixedPrize: 'Les clients reçoivent un prix fixe',
      ChoosePrize: 'Les clients choisissent leur prix préféré',

      PrizeMode: 'Mode de jeu',
      FixedPrizeMode: 'Les clients attrapent un prix fixe',
      RandomPrizeMode: 'Le client obtient un prix aléatoire (blindbox)',
      PrizeModeSwitchTitle: 'Changer le mode de prix ?',
      PrizeModeSwitchWarning:
        'Les modes Prix fixe et Prix aléatoire donnent un sens différent à un prix : le changement recrée tous les prix de cette campagne. Les probabilités de gain sont effacées et chaque prix reçoit une nouvelle référence.',

      GameTry: 'Essai de jeu',
      AwardBadges: 'Attribuer des badges',
      AwardPoints: 'Attribuer des points',
      AddRewards: 'Ajouter des récompenses',
      AddPrizeToSet: "Ajouter un prix à l'ensemble",
      IncludeNoPrizeAsOutcome: 'Inclure "aucun prix" comme résultat',
      RandomOutcomeSet: 'Ensemble de résultats aléatoires {{index}}',
      PrizeSet: 'Ensemble de prix {{index}}',

      LevelsAndPrizes: 'Niveaux & Prix',
      LandingPage: "Page d'accueil",
      ProgressMechanics: 'Mécanique de progression',

      InstantRewardMechanics: 'Mécanique de récompense instantanée',
      ListCheckboxLabel: "Afficher la campagne dans la liste des campagnes de l'utilisateur ?",
      ListCheckboxSendPushNotificationLabel:
        'Envoyer une notification push à chaque déclenchement de règle ?',
      MediaTagsToInclude: 'Tags média à inclure',
      SelectMediaTags: 'Sélectionner les tags média',
      AddRule: 'Ajouter une règle',
      Name: 'Nom',
      Action: 'Action',
      Edit: 'Modifier',
      Remove: 'Supprimer',

      IssuanceLimits: "Limites d'émission",
      TotalNumberOfIssuePrizeEventsOnCampaignLevel:
        "Nombre total d'événements de remise de prix (au niveau de la campagne)",
      TotalNumberOfIssuePrizeEventsPerUser:
        "Nombre total d'événements de remise de prix (par utilisateur)",
      IssuanceLimitsPerUser: "Limites d'émission (par utilisateur)",
      IssuanceLimitsPerUserPlaceholder: '∞',
      IssuePrizeEvents: 'événement(s) de remise de prix',
      RateLimitOnCampaignLevel: 'Limite de fréquence (au niveau de la campagne)',
      IssuePrizeEventsForEvery: 'événement(s) de remise de prix pour chaque',
      Day: 'jour',
      RateLimitPerUser: 'Limite de fréquence (par utilisateur)',
      LimitTo: 'Limiter à',
      LeaveTheLimitFieldsBlankForUnlimitedIssuePrizeEvents:
        "^ Laisser le champ de limite vide pour un nombre illimité d'événements de remise de prix",
      SvgHarmfulTagsRemovedSuccessfully: 'Balises SVG nuisibles supprimées avec succès !',
      ImageHelpText: 'Ratio 1:1 recommandé, 500ko max en jpg ou png',
      Upload: 'Télécharger',

      PrizeEarnedPopUp: 'Fenêtre contextuelle de prix gagné',
      AppearsUponCustomerSignInToMicrosite:
        'Apparaît lors de la connexion du client à la microsite',
      Headline: 'Titre',
      PleaseInputYourHeadline: 'Veuillez saisir votre titre',
      SubHeadline: 'Sous-titre',
      PleaseInputYourSubHeadline: 'Veuillez saisir votre sous-titre',
      Image: 'Image',
      ClaimPrizeButtonText: 'Texte du bouton pour réclamer le prix',
      PleaseInputClaimPrizeButtonText: 'Veuillez saisir le texte du bouton pour réclamer le prix',
      AddTask: 'Ajouter une tâche',
      SomethingWentWrong: "Une erreur s'est produite",
      MaxNumberReachedWarning: 'Limite de 10 tâches par quête atteinte',
      TaskIndex: 'Tâche {{index}}',
      WinProbability: 'Probabilité de gain:',
      WinProbabilityPercent: 'Probabilité de gain %',
      loyaltypoints: 'points de fidélité',
      loyaltypoint: 'point de fidélité',

      StampRuleTable: {
        ID: 'ID',
        Name: 'Nom',
        RuleType: 'Type de règle',
        NumberOfStamps: 'Nombre de tampons',
        RaffleTicketsColumn: 'Tickets de tombola',
        RaffleTicketsVariableValue: '{{x}} par {{y}} (max. {{z}})',
        Action: 'Action',
        Edit: 'Modifier',
        Remove: 'Supprimer'
      },

      SelectOutcomes: 'Sélectionner les résultats',
      OnlyRewardsWithConfiguredTags:
        'Seules les récompenses avec des tags configurés peuvent être sélectionnées lorsque les clients choisissent leur prix.',
      ConfigureRaffleCodes: {
        Title: 'Configurer les codes de tirage au sort',
        SelectCodeType: 'Sélectionner le type de code',
        SystemGenerated: 'Généré par le système',
        UserUpload: 'Téléchargement utilisateur',
        TicketCodePrefix: 'Préfixe du code du ticket',
        LengthOfCode: 'Longueur du code',
        NumberOfTickets: 'Nombre de tickets',
        CodeFormat: 'Format du code',
        TotalPermutations: 'Total des permutations',
        SelectFile: 'Sélectionner un fichier',
        UploadCodes: 'Télécharger les codes',
        AcceptedFormats: 'Formats acceptés : uniquement fichiers .txt, .xlsx ou .csv.'
      },

      RaffleRules: {
        Title: 'Règles de gain',
        AddRule: 'Ajouter une règle'
      },

      GrandPrizes: {
        Title: 'Grands prix',
        LimitGrandPrizesToOnePerCustomerOnly: 'Limiter les grands prix à un seul par client',
        ThisSettingRequiresMultipleGrandPrizesToBeDefined:
          'Ce paramètre nécessite que plusieurs grands prix soient définis',
        AllocateRafflePrizesForIndividualPositionsOrARange:
          'Attribuer des prix de tirage au sort pour des positions individuelles ou une plage. Par ex. ensemble de prix 1 pour le 1er, ensemble de prix 2 pour les 2e à 5e places.',
        AddPrizeSet: 'Ajouter un ensemble de prix',
        Position: 'Position :',
        PrizeSetWithPositionStartsWith: 'Ensemble de prix {{index}} : position commence à',
        PrizeSetWithPosition: 'Ensemble de prix {{index}} : position',
        PrizeSet: 'Ensemble de prix {{index}}',
        ConvertPositionToRange: 'Convertir la position en plage'
      },

      OutcomeSettings: {
        Title: 'Paramètres de résultat - apparaît lors de la connexion du client à la microsite',
        RaffleTicketOutcome: 'Résultat du ticket de tirage au sort',
        GrandPrizeOutcome: 'Résultat du grand prix',
        RaffleTicket: 'Ticket de tirage au sort',
        GrandPrize: 'Grand prix',
        Headline: 'Titre',
        Subheadline: 'Sous-titre',
        WinRewardGraphic: 'Graphique de récompense gagnée',
        ClaimTicketButtonText: 'Texte du bouton pour réclamer le ticket',
        ClaimPrizeButtonText: 'Texte du bouton pour réclamer le prix'
      },

      QuestMechanics: {
        Title: 'Mécanique de quête',
        SequentialTasks: "Les tâches de la quête doivent être complétées dans l'ordre",
        Yes: 'Oui',
        No: 'Non',
        UserTriesValidity: 'Validité des essais utilisateur',
        UserTriesValidityPlaceholder: '100',
        UserTriesValidityPeriodPlaceholder: 'jours',
        Hours: 'heures',
        Days: 'jours',
        Months: 'mois',
        Years: 'années',
        TotalNumberofQuests: 'Nombre total de quêtes pouvant être commencées dans une campagne',
        TotalNumberofQuestsPlaceholder: '∞',
        Quests: 'quêtes',
        TotalNumberofQuestsPerUser:
          'Nombre total de quêtes pouvant être commencées par chaque utilisateur',
        TotalNumberofQuestsPerUserPlaceholder: '∞',
        LeaveTheLimitFieldsBlankForUnlimitedIssuances:
          "^ Laisser le champ de limite vide pour un nombre illimité d'émissions",
        QuestDisplaySetUp: "Configuration de l'affichage de la quête",
        Headline: 'Titre',
        SubHeadline: 'Sous-titre',
        BodyText: 'Texte principal',
        Image: 'Image',
        ImageHelpText: 'Taille min 360(l) x 144(h) px en jpg ou png',
        TasksDisplay: 'Affichage des tâches',
        TaskIndex: 'Tâche {{index}}',
        TaskDoneBadge: 'Badge de tâche terminée',
        TaskDoneBadgeHelpText: 'l : 130px &times; h : 130px',
        TaskHeadline: 'Titre de la tâche',
        TaskSubHeadline: 'Sous-titre de la tâche',
        TaskIcon: 'Icône de la tâche',
        ButtonText: 'Texte du bouton',
        ButtonExternalLink: 'Lien externe du bouton'
      },

      QuizQuestions: {
        Title: 'Questions',
        AddQuestion: 'Ajouter une question',
        Type: 'Type',
        TextQuestion: 'Question texte',
        ImageQuestion: 'Question image',
        WrittenResponse: 'Réponse écrite',
        MultipleAnswers: 'Réponses multiples',
        SingleAnswer: 'Réponse unique',
        Question: 'Question',
        Required: 'Obligatoire',
        Actions: 'Actions',
        Edit: 'Modifier',
        Delete: 'Supprimer',

        EditQuestion: 'Modifier la question',
        UpdateQuestion: 'Mettre à jour la question',
        Cancel: 'Annuler',
        QuestionType: 'Type de question',
        TextChoice: 'Choix texte',
        ImageChoice: 'Choix image',
        CharactersLeft: 'caractères restants',
        Description: 'Description',
        ImageHelpText: 'l : 360px &times; h : 145px | Autorisé : .jpg, .jpeg, .png, .svg',
        LabelForQuestionImage: "Libellé pour l'image de la question",
        RequiredToAnswer: 'Réponse obligatoire',
        RequiredToAnswerDescription:
          'Les participants à l’enquête pourront saisir leur réponse dans une zone de texte, comme ci-dessous :',
        InputFieldExample: 'Exemple de champ de saisie',
        AllowSelectingMultipleAnswers: 'Autoriser la sélection de plusieurs réponses',
        ChooseCorrectAnswer: 'Choisir la bonne réponse',
        IsSurveyChoice: 'Choix #{{index}}',
        AnswerChoice: 'Choix de réponse #{{index}}',
        Option: 'Option #{{index}}',
        EachQuestionRequiresAtLeastTwoAnswers: 'Chaque question nécessite au moins deux réponses',
        AddAnother: 'Ajouter un autre',
        Answer: 'réponse',

        ShowOthers: 'Afficher « Autre (veuillez préciser) : »',
        Other: 'Autre (veuillez préciser) :',

        RequiredField: 'Ce champ est obligatoire !',
        YouNeedToTypeIn: 'Vous devez saisir',
        AnAnswer: 'une réponse',
        AQuestion: 'une question',
        OrUploadAnImage: 'ou télécharger une image',
        YouNeedToSelectMoreThanOneCorrectAnswer: 'Vous devez sélectionner plus d’une bonne réponse',
        YouNeedToSelectAtLeastOneCorrectAnswer:
          'Vous devez sélectionner au moins une bonne réponse',
        PleaseTypeInYourAnswer: 'Veuillez saisir votre réponse',
        Recommended: 'Recommandé : 720px par 120px | Autorisé : .jpg, .png, .svg',
        Upload: 'Télécharger'
      },

      QuizTimer: {
        Title: 'Minuteur du quiz',
        SetATimeLimitForEachQuestion: 'Définir une limite de temps pour chaque question',
        CountUp: 'Compter vers le haut',
        CountDown: 'Compte à rebours',
        MaximumCount: 'Compte maximum',
        MaximumCountPlaceholder: '∞',
        Seconds: 'Secondes'
      },

      QuizLimits: {
        Title: 'Limites du quiz',
        SurveyLimits: 'Limites de l’enquête',
        QuizLimits: 'Limites du quiz',
        AutoIssueMoves: 'Déclenchement automatique des déplacements',
        TotalLimitsInTheCampaignIs: 'Le total des limites {{campaingType}} dans la campagne est',
        InfiniteUses: 'REMARQUE : Pour un nombre illimité d’utilisations, laissez le champ vide.',
        IndividualUsersCanOnlyAttemptThisQuiz:
          'Chaque utilisateur ne peut tenter ce {{campaingType}} qu’une seule fois',
        InfiniteUsers: 'REMARQUE : Pour un nombre illimité d’utilisateurs, laissez le champ vide.',
        TimesInTotal: 'fois au total',
        TimesPer: 'fois par',
        Day: 'jour',
        Week: 'semaine',
        Month: 'mois',
        Year: 'an',
        BlockUsersWhoAchieved100PercentCorrect:
          "Bloquer les utilisateurs ayant obtenu 100 % de bonnes réponses afin d'empêcher toute nouvelle tentative",
        BlockUsersWhoAchieved100PercentCorrectNote:
          "REMARQUE : Une fois qu'un client a répondu correctement à toutes les questions de ce quiz, il ne pourra plus répondre au quiz, même s'il lui reste des essais de jeu."
      },
      QuizValidity: {
        Survey: 'Enquête',
        Quiz: 'Quiz',
        Title: 'Validité du/de la {{campaingType}}',
        AfterIssueTheQuizWillExpireIn: 'Après émission, le/la {{campaingType}} expirera dans',
        QuizLimitPlaceholder: '100',
        Days: 'jours',
        Months: 'mois',
        Years: 'années'
      },
      QuizGraphicsSettings: {
        Title: 'Propriétés du quiz',
        AppBackground: "Arrière-plan de l'application",
        FontColour: 'Couleur de la police',
        CTAButtonBackgroundColour: 'Couleur de fond du bouton CTA',
        CTAButtonTextColour: 'Couleur du texte du bouton CTA',
        HelpText: 'l : 375px &times; h : 812px'
      },
      MicrositeGraphicsSettings: {
        Title: 'Propriétés d’affichage de la microsite',
        LandingScreen: "Écran d'accueil",
        OutcomeSettings: 'Paramètres de résultat',
        Body: 'Corps',
        InsertYouTubeEmbedURLHere: 'Insérer l’URL d’intégration YouTube ici',
        ButtonText: 'Texte du bouton',
        OutcomeSettingsScoreResult: 'Paramètres de résultat',
        SuccessfulOutcomeHeadline: 'Titre du résultat réussi',
        SuccessfulOutcomeBody: 'Corps du résultat réussi',
        SuccessfulOutcomeImage: 'Image du résultat réussi',
        SuccessfulOutcomeImageHelpText: 'l : 400px &times; h : 400px',
        SuccessfulOutcomeButton: 'Bouton du résultat réussi',
        NoOutcomeTitle: 'Titre en cas d’absence de résultat',
        NoOutcomeSubheadline: 'Sous-titre en cas d’absence de résultat',
        NoOutcomeImage: 'Image en cas d’absence de résultat',
        NoOutcomeButton: 'Bouton en cas d’absence de résultat'
      },

      CampaignSelectModal: {
        Title: 'Sélectionner une campagne',
        OkText: 'Ajouter la campagne',
        CancelText: 'Annuler',
        SearchPlaceholder: 'Rechercher une campagne par nom, type ou commerçant',
        Name: 'Nom',
        Status: 'Statut',
        Tags: 'Tags',
        StartDate: 'Date de début',
        EndDate: 'Date de fin',
        Active: 'Active',
        Scheduled: 'Planifiée',
        ID: 'ID'
      }
    },

    Outcomes: {
      SelectOutcomes: 'Sélectionner les résultats',
      Name: 'Nom',
      Action: 'Action',
      EditPoints: 'Modifier les points',
      Remove: 'Supprimer',
      EditReferralRule: 'Modifier la règle de parrainage',
      MoveToTop: 'Déplacer en haut',
      MerchantName: 'Nom du marchand',
      SellingFrom: 'Vente à partir de',
      SellingTo: "Vente jusqu'à",
      RewardBalance: 'Solde de récompense',
      PointsAwarded: 'Points attribués',
      ReferrerLimits: 'Limites du parrain',
      ReferralsNeeded: 'Parrainages nécessaires',
      RefereeRewardLimit: 'Limite de récompense du filleul',
      AwardBadges: 'Attribuer des badges',
      AwardPoints: 'Attribuer des points',
      AddRewards: 'Ajouter des récompenses',
      ExpiresInDays: 'Expires in {{count}} days',
      AwardGameTry: 'Attribuer un essai de jeu',
      EditGameTry: "Modifier l'essai de jeu",
      ReferrerGameTryIssued: 'Essai de jeu Parrain',
      RefereeGameTryIssued: 'Essai de jeu Filleul'
    },

    CampaignRules: {
      AddRule: 'Ajouter une règle'
    },

    RuleGroup: {
      Mechanic: 'Mécanique'
    },

    RefferalSelectionModal: {
      Title: 'Modifier la règle de parrainage',
      OnCancelError: "La valeur de parrainage n'est pas un nombre ! Veuillez vérifier !",
      OkButtonText: 'OK',
      RewardId: 'ID de récompense :',
      Referee: 'Filleul',
      Referrer: 'Parrain',
      NoOfReferralsNeeded: 'Nombre de parrainages nécessaires',
      TotalRewardLimit: 'Limite totale de récompense',
      RewardLimit: 'Limite de récompense',
      RewardBalance: 'Solde de récompense : ',
      CheckboxError: 'Les options Parrain ou Filleul sont requises',
      RewardIDTitle: 'ID de récompense :',
      Points: 'Points',
      Of: ' sur ',
      TotalOutcomeLimit: 'Limite totale de résultat',
      OutcomeLimit: 'Limite de résultat',
      NumberError: 'Cette valeur doit être un nombre',
      RequiredError: 'Cette valeur est requise'
    },

    CampaignReferralRewardPickerModal: {
      SearchRewards: 'Rechercher des récompenses',
      Active: 'Actif',
      Private: 'Privé',
      Approved: 'Approuvé',
      System: 'Système',
      SelectRewards: 'Sélectionner des récompenses',
      Back: 'Retour',
      Next: 'Suivant',
      Done: 'Terminé',
      Name: 'Nom',
      MerchantName: 'Nom du marchand',
      SellingFrom: 'Vente à partir de',
      SellingTo: "Vente jusqu'à",
      RewardBalance: 'Solde de récompense',
      SetupReferralRule: 'Configurer la règle de parrainage'
    },

    RewardPicker: {
      SelectRewards: 'Sélectionner des récompenses',
      OkButtonText: 'Ajouter des récompenses',
      SearchRewards: 'Rechercher une récompense par nom, type ou marchand',
      Active: 'Actif',
      Private: 'Privé',
      Approved: 'Approuvé',
      System: 'Système',
      Ended: 'Terminé',
      Inactive: 'Inactif',
      Draft: 'Brouillon',
      Name: 'Nom',
      MerchantName: 'Nom du marchand',
      SellingFrom: 'Vente à partir de',
      SellingTo: "Vente jusqu'à",
      RewardBalance: 'Solde de récompense'
    },

    CampaignReferralPointsModal: {
      PleaseSelectGLAccount: 'Veuillez sélectionner un compte GL',
      PleaseSelectGLAccountTypeAndName: 'Veuillez sélectionner un compte GL, type et nom',
      PleaseSetNumberOfPointsToAward: 'Veuillez définir le nombre de points à attribuer',
      SetPointsToAward: 'Définir les points à attribuer',
      Next: 'Suivant',
      Done: 'Terminé',
      SelectLoyaltyProgram: 'Sélectionner le programme de fidélité',
      HowManyPoints: 'Combien de points ?',
      SelectGLAccount: 'Sélectionner le compte GL',
      SelectGLAccountType: 'Sélectionner le type de compte GL',
      SelectGLAccountName: 'Sélectionner le nom du compte GL',
      SelectGLAccountNamePlaceholder: 'Nom',
      EnterPoints: 'Saisir les points',
      SetupReferralRule: 'Configurer la règle de parrainage',
      AwardedPointsExpireIn: 'Awarded points expire in',
      NumberOfDaysPlaceholder: 'e.g., 7',
      Days: 'days'
    },

    CampaignReferralGameTryModal: {
      SelectCampaigns: 'Sélectionner les campagnes',
      SetupReferralRule: 'Configurer la règle de parrainage',
      NumberOfGameTry: "Nombre d'essais de jeu",
      WarningText:
        "Seules les campagnes avec l'émission automatique d'essais de jeu désactivée peuvent être sélectionnées pour l'émission d'essais de jeu.",
      CampaignID: 'ID Campagne: {{id}}, {{name}}',
      Back: 'Retour',
      Next: 'Suivant',
      Done: 'Terminé',
      SearchCampaigns: 'Rechercher des campagnes',
      Active: 'Actif',
      Scheduled: 'Planifié',
      Referee: 'Filleul',
      Referrer: 'Parrain',
      NoOfReferralsNeeded: 'Nombre de parrainages requis'
    },

    GameTypesSelectModal: {
      Title: 'Sélectionner un type de jeu',
      OkButtonText: 'Sélectionner',
      CancelButtonText: 'Annuler',

      ShakeTheTree: {
        Title: "Secouer l'arbre",
        InstructionsLineOne:
          'Engagez les clients avec un défi qui nécessite de secouer le téléphone',
        InstructionsLineTwo: 'Mécaniques de jeu',
        InstructionsLineThree:
          "1. L'utilisateur final obtient une récompense en accomplissant une action requise, dans ce cas en secouant l'arbre",
        InstructionsLineFour:
          '2. Les récompenses sont distribuées aléatoirement selon la probabilité définie sur les récompenses',
        InstructionsLineFive: 'Idéal pour',
        InstructionsLineSix: '1. Jeu saisonnier'
      },
      HitThePinata: {
        Title: 'Frapper la Piñata',
        InstructionsLineOne: 'Engagez les clients avec un défi qui nécessite de frapper la piñata',
        InstructionsLineTwo: 'Mécaniques de jeu',
        InstructionsLineThree:
          "1. L'utilisateur final obtient une récompense en accomplissant une action requise, dans ce cas en frappant la piñata",
        InstructionsLineFour:
          '2. Les récompenses sont distribuées aléatoirement selon la probabilité définie sur les récompenses',
        InstructionsLineFive: 'Idéal pour',
        InstructionsLineSix: '1. Jeu saisonnier'
      },
      ScratchCard: {
        Title: 'Carte à gratter',
        InstructionsLineOne:
          'Engagez les clients en les faisant gratter pour gagner des prix excitants',
        InstructionsLineTwo: 'Mécaniques de jeu',
        InstructionsLineThree:
          "1. L'utilisateur final obtient une récompense en accomplissant une action requise, dans ce cas en grattant la carte",
        InstructionsLineFour:
          '2. Les récompenses sont distribuées aléatoirement selon la probabilité définie sur les récompenses',
        InstructionsLineFive: 'Idéal pour',
        InstructionsLineSix: '1. Jeu saisonnier'
      },
      SpinTheWheel: {
        Title: 'Tourner la roue',
        InstructionsLineOne:
          'Engagez les clients en les faisant tourner la roue pour gagner des prix excitants',
        InstructionsLineTwo: 'Mécaniques de jeu',
        InstructionsLineThree:
          "1. L'utilisateur final obtient une récompense en accomplissant une action requise, dans ce cas en tournant la roue",
        InstructionsLineFour:
          '2. Les récompenses sont distribuées aléatoirement selon la probabilité définie sur les récompenses',
        InstructionsLineFive: 'Idéal pour',
        InstructionsLineSix: '1. Jeu saisonnier'
      },
      Plinko: {
        Title: 'Plinko',
        InstructionsLineOne:
          "Engagez les clients en les faisant tenter leur chance pour faire tomber la balle dans l'emplacement gagnant",
        InstructionsLineTwo: 'Mécaniques de jeu',
        InstructionsLineThree:
          "1. L'utilisateur final obtient une récompense en accomplissant une action requise, dans ce cas en faisant tomber la balle",
        InstructionsLineFour:
          '2. Les récompenses sont distribuées aléatoirement selon la probabilité définie sur les récompenses',
        InstructionsLineFive: 'Idéal pour',
        InstructionsLineSix: '1. Jeu saisonnier'
      },
      BubblePop: {
        Title: 'Pop de bulles',
        InstructionsLineOne:
          'Faites participer les clients avec un défi amusant et rapide qui offre de vraies récompenses',
        InstructionsLineTwo: 'Mécanique du jeu',
        InstructionsLineThree:
          '1. L’utilisateur marque des points en appuyant sur des bulles colorées en 30 secondes',
        InstructionsLineFour:
          '2. Chaque couleur de bulle vaut un nombre de points positif ou négatif différent — soyez stratégique',
        InstructionsLineFive:
          '3. En fonction de leur score final, les utilisateurs reçoivent instantanément des points de fidélité, des bons, des essais de jeu ou des billets de tombola',
        InstructionsLineSix:
          '4. Plus le score est élevé, meilleure est la récompense — compétence pure, sans hasard',
        InstructionsLineSeven: 'Idéal pour',
        InstructionsLineEight:
          'Campagnes où vous souhaitez récompenser l’engagement, pas seulement la chance'
      },
      ClawMachine: {
        Title: 'Machine à griffes',
        InstructionsLineOne:
          'Un jeu amusant qui mêle adresse et hasard. Mettez vos clients au défi d’attraper le prix qu’ils convoitent avant la fin du temps imparti !',
        InstructionsLineTwo: 'Mécaniques de jeu',
        InstructionsLineThree:
          '1. Les utilisateurs déplacent la griffe à gauche et à droite pour la positionner au-dessus du prix qu’ils veulent.',
        InstructionsLineFour:
          '2. Appuyez sur le bouton ‘Attraper’ pour tenter de saisir le prix avant la fin du temps.',
        InstructionsLineFive: '3. En cas de réussite, l’utilisateur remporte le prix.',
        InstructionsLineSix: 'Idéal pour',
        InstructionsLineSeven:
          'Les campagnes d’engagement répété, les boîtes aveugles ou pour inciter les utilisateurs à échanger leurs points contre une chance de gagner un prix'
      }
    },

    StreakTypesSelectModal: {
      SelectStreakCampaignType: 'Sélectionner le type de campagne Streak',
      ContinuousLoop: 'Boucle continue',
      Progressive: 'Progressif',
      CheckIn: 'Enregistrement',
      MilestoneBased: 'Basée sur des étapes',
      TransactionCount: 'Nombre de transactions',
      CumulativeSpend: 'Dépense cumulative',
      ContinuousLoopDescription:
        'Gardez les clients engagés en leur faisant accomplir des tâches à plusieurs reprises dans une période fixe, et ils reçoivent une récompense à chaque fois.',
      GameMechanicsTitle: 'Mécanique du jeu',
      ContinuousLoopGameMechanicsLineOne:
        '1. Le jeu est défini pour une période fixe - quotidienne, hebdomadaire ou mensuelle.',
      ContinuousLoopGameMechanicsLineTwo:
        '2. Les utilisateurs doivent accomplir une tâche spécifique plusieurs fois pendant la période. Une fois les tâches terminées, ils reçoivent la récompense, et la campagne redémarre automatiquement pour la période suivante.',
      IfCustomersMissAStreakTheyStartAgainAtTheNextStreakPeriod:
        '3. Si les clients manquent une série, ils recommencent à la période de série suivante.',
      ContinuousLoopIdealForTitle: 'Idéal pour',
      ContinuousLoopIdealForLineOne: '1. Campagnes de connexion quotidienne',

      MilestoneBasedDescription:
        'Définissez des objectifs progressifs pour vos clients afin qu’ils accomplissent des tâches répétées, avec un prix attribué à chaque étape atteinte.',
      MilestoneBasedGameMechanicsTitle: 'Mécanique du jeu',
      MilestoneBasedGameMechanicsLineOne:
        '1. Le jeu est défini avec un intervalle fixe - quotidien, hebdomadaire ou mensuel.',
      MilestoneBasedGameMechanicsLineTwo:
        '2. Le jeu comporte une tâche définie que les utilisateurs doivent effectuer à plusieurs reprises - par ex. : Connexion, transaction spécifique, etc.',
      MilestoneBasedGameMechanicsLineThree:
        '3. Définissez des jalons selon le nombre de tâches à effectuer et le nombre de périodes continues nécessaires.',
      MilestoneBasedGameMechanicsLineFour:
        '4. Les clients reçoivent un prix chaque fois qu’ils atteignent le jalon. S’ils manquent une série, ils recommencent au jalon actuel. Les prix ne sont attribués qu’une seule fois par jalon.'
    },

    TeamsMechanics: {
      Title: "Mécaniques d'équipe",
      Description:
        "Les paramètres des mécaniques d'équipe ne peuvent pas être mis à jour une fois qu'une campagne a été publiée.",
      ActivateTeamMechanics: "Activer les mécaniques d'équipe",
      TeamSize: 'Utilisateurs par équipe',
      LandingScreen: "Écran d'accueil",
      Image: 'Image',
      ImageHelpText: 'Taille min 360(l) x 144(h) px en jpg ou png',
      PreEnrollmentMessage: 'Message pré-inscription',
      StampsEarnMessage: 'Message de gain de tampons',
      GameplayInstructions: 'Instructions de jeu',
      JoinTeamPage: 'Page rejoindre une équipe',
      JoinTeamInfoMessage: "Message d'info pour rejoindre une équipe",
      InviteMemberMessage: "Message d'invitation de membre",
      InviteCodeBlurb: "Texte du code d'invitation",
      CharactersUsed: 'Caractères utilisés',
      Note: 'Note',
      NoteDescriptionOne: 'À la fois le',
      NoteDescriptionTwo: "message d'invitation de membre",
      NoteDescriptionThree: 'et le',
      NoteDescriptionFour: "texte du code d'invitation",
      NoteDescriptionFive:
        'sont utilisés pour générer le "message de partage". Nous n\'avons pas mis de limite à la longueur de ce message - mais gardez à l\'esprit que les messages SMS ont une limite de 160 caractères par message',

      DefaultPreEnrollmentMessagePartOne: 'Créez ou rejoignez une équipe de {{teamSize}} membres',
      DefaultPreEnrollmentMessagePartTwo: 'Vous pouvez créer ou rejoindre 1 équipe.',
      DefaultStampsEarnMessagePartOne: "Gagnez des tampons en faisant l'une des actions suivantes",
      DefaultStampsEarnMessagePartTwo: 'Faire KYC',
      DefaultStampsEarnMessagePartThree: 'Passer aux relevés électroniques',
      DefaultParticipationInfoMessagePartOne:
        "Gagnez des récompenses en faisant l'une des actions suivantes",
      DefaultParticipationInfoMessagePartTwo: 'Faire KYC',
      DefaultParticipationInfoMessagePartThree: 'Passer aux relevés électroniques',
      DefaultTeamCompleteButtonText: 'Vérifier votre progression',
      DefaultTeamCompleteButtonTextStamp: 'Voir vos cartes de tampons',
      DefaultTeamIncompleteButtonText: 'Rejoindre une équipe',
      DefaultTeamIncompleteButtonTextSecondary: 'Créer une équipe',
      DefaultJoinTeamPageDescriptionPartOne:
        "Une équipe n'est considérée comme active que lorsque {{teamSize}} membres se sont engagés à la rejoindre.",
      DefaultJoinTeamPageDescriptionPartTwo:
        'Entrez le code/url dans le champ ci-dessus et cliquez sur rejoindre',
      DefaultJoinTeamPageDescriptionPartThree:
        'Attendez que {{teamSize}} membres se soient engagés',
      DefaultJoinTeamPageDescriptionPartFour: 'Collectez des tampons en équipe',
      DefaultJoinTeamPageDescriptionPartFive: 'Jouez en équipe',
      DefaultJoinTeamPageDescriptionPartSix:
        "Les individus ne peuvent faire partie que d'1 équipe (créée ou rejointe)",
      DefaultInviteMessageDescriptionPartOne: 'Bonjour, rejoignez mon équipe pour',
      DefaultInviteMessageDescriptionPartTwo: ' remplir des cartes de tampons ',
      DefaultInviteMessageDescriptionPartThree: ' jouer à des jeux ',
      DefaultInviteMessageDescriptionPartFour: ' et gagner des prix ensemble !',
      DefaultInviteMessageCodeBlurb: "Utilisez mon code d'équipe :"
    },

    EnrolMechanics: {
      EnrolmentMechanics: "Mécaniques d'inscription",
      AutoEnrolUsers: 'Inscription automatique des utilisateurs',
      EnrollableUntil: "Inscription possible jusqu'au",
      AutoFillStamps: 'Remplissage automatique des tampons',
      EnableCampaignDurationMechanics: 'Activer les mécaniques de durée de campagne',
      UsersMustCompleteTheCampaignWithin: 'Les utilisateurs doivent terminer la campagne dans',
      AutoRedeemOutcome: 'Résultat de rachat automatique',
      SendMicrositeNotification:
        'Envoyer une notification microsite pour le résultat auto-échangé ?',
      Yes: 'Oui',
      No: 'Non'
    },

    StreakMechanics: {
      StreakMechanics: 'Mécanique de série',
      SelectTaskType: 'Sélectionner le type de tâche',
      CumulativeSpend: 'Dépense cumulative',
      TransactionCount: 'Nombre de transactions',
      SignIn: 'Connexion',
      StreakRequirements: 'Exigences de série',
      TargetCriteria: 'Critères cibles',
      UserMustPerformTheTask: "L'utilisateur doit effectuer la tâche",
      TimesWithinOne: 'fois dans 1',
      StreakTarget: 'Objectif de série',
      Continuous: 'consécutifs',
      Days: 'jours',
      Weeks: 'semaines',
      Months: 'mois',
      SelectTrigger: 'Sélectionner le déclencheur',
      MilestonesAndPrizes: 'Étapes et récompenses',
      TargetMake: 'Objectif : effectuer',
      ValidTransactionsEvery: 'transactions valides chaque',
      For: 'pendant',
      Level: 'Niveau',
      MustBeMoreThanLevel: 'doit être supérieur au niveau',
      SelectStreakDuration: 'Sélectionner la durée de la série',
      Daily: 'Quotidien',
      Weekly: 'Hebdomadaire',
      Monthly: 'Mensuel',
      AtLeastOneConditionIsRequired: 'Au moins une condition est requise',
      CustomerSignIn: 'Connexion client',
      TransactionCreated: 'Transaction créée',
      TargetSpend: 'Cible : Dépense',
      CurrencyEvery: 'devise chaque',
      TargetSignIn: 'Cible : Connexion',
      TimesEvery: 'fois chaque',
      Perform: 'effectuer',
      Signin: 'se connecter',
      Transaction: 'transaction',
      Spend: 'dépenser',
      PerformTheTask: 'effectuer la tâche',
      InOrderToWinThePrize: 'afin de gagner le prix',
      MakeTransactionAtLeast: 'effectuer une transaction au moins',
      Times: 'fois',
      AtLeast: 'au moins',
      Where: 'où',
      CurrencyOnTransactionsWhere: 'devise, sur les transactions où',
      MakeTransaction: 'effectuer une transaction'
    },

    LandingPage: {
      Title: "Page d'accueil",
      Headline: 'Titre',
      SubHeadline: 'Sous-titre',
      BodyText: 'Corps du texte',
      Image: 'Image',
      CTAButtonText: 'Texte du bouton CTA',
      CTAButtonColour: 'Couleur du bouton CTA',
      CTAButtonTextColour: 'Couleur du texte du bouton CTA',
      TermsAndConditions: 'Conditions générales',

      ImageHelpText: 'Format recommandé 16:9, 500ko max en jpg ou png',
      IssuePrizeDescription: "Description de l'émission de prix",
      IssuePrizeDescriptionPlaceholder: "Veuillez saisir la description de l'émission de prix",
      PleaseInputYourHeadline: 'Veuillez saisir votre titre',
      PleaseInputYourSubHeadline: 'Veuillez saisir votre sous-titre',

      ImageMinRequirements: 'Taille min 360(l) x 144(h) px en jpg ou png',
      AspectRatioRecommendation: 'Format 16:9 recommandé, 500 Ko max en jpg ou png',

      LevelsTab: "Onglet 'Niveaux'",
      HowToParticipateTab: "Onglet 'Comment participer'",
      TabName: "Nom de l'onglet",
      CampaignPointsShortForm: 'Abréviation des points de campagne',
      LevelProgressBadges: 'Badges de progression de niveau',
      LevelCompletedBadge: "Badge 'Niveau terminé'",
      LevelInProgressBadge: "Badge 'Niveau en cours'",
      LevelNotStartedBadge: "Badge 'Niveau non commencé'",
      LevelCompletedBadgeHelpText: '92px par 92px recommandé, 100ko max en jpg ou png',
      IssuePrizelabel: "Description de l'émission de prix",
      LevelCompletedBadgeIcon: 'Icône du niveau {{index}}',
      Text: 'Texte',

      CompleteLevelAndStandToWinAPrizeSetIncluding:
        'Terminez le niveau et tentez de gagner un ensemble de prix comprenant :',
      ParticipateAndWinExcitingPrizes: 'Participez et gagnez des prix passionnants !',
      HowToParticipate: 'Comment participer',
      AddLevel: 'Ajouter un niveau',
      PointsRequiredForCampaignCompletion: 'Points requis pour terminer la campagne :',

      OutcomeSettings: {
        Title: 'Paramètres de résultat',
        Badges: 'Badges',
        Vouchers: 'Bons',
        Points: 'Points',
        PrizeSet: 'Ensemble de prix',
        MixedRewards: 'Récompenses mixtes',
        Submit: 'Soumettre',
        MixedRewardsButtonText: 'Texte du bouton basé sur la première récompense listée',
        Headline: 'Titre',
        CharactersLeft: 'caractères restants',
        MixedRewardsMessage:
          "Pour un ensemble de prix, le texte et l'action du bouton seront basés sur la première récompense listée dans les résultats.",
        ButtonText: 'Texte du bouton',
        Graphic: 'Graphique',
        GraphicHelpText: 'l : 400px  ×  h : 400px',

        BadgesHeadline: 'Félicitations ! Vous avez gagné un badge !',
        BadgesButtonText: 'Voir mes badges',
        VouchersHeadline: 'Félicitations ! Vous avez gagné un bon !',
        VouchersButtonText: 'Aller à mes bons',
        PointsHeadline: 'Félicitations ! Vous avez gagné des points !',
        PointsButtonText: 'Voir mes points',
        MixedRewardsHeadline: 'Félicitations ! Vous avez gagné des récompenses !',
        GameTries: 'Essais de jeu',
        GameTriesHeadline: 'Vous avez gagné des essais de jeu pour {campaign_name} !',
        GameTriesButtonText: 'Jouer maintenant',
        NoOutcome: 'Aucun résultat',
        NoOutcomeHeadline: "Vous n'avez rien gagné. Plus de chance la prochaine fois.",
        PlayAgainButtonText: 'Rejouer',
        ClawVouchersHeadline: 'Félicitations. Vous avez gagné un bon !',
        ClawPointsHeadline: 'Félicitations. Vous avez gagné des points !',
        ClawBadgesHeadline: 'Félicitations. Vous avez gagné un badge !'
      },

      EndsOnDate: 'Se termine le {{date}}',
      FromDate: 'À partir du {{date}}',
      ParticipateAndStandToWin: 'Participez et tentez de gagner UN des prix suivants :',
      CongratsYouEarnedAPrize: 'Félicitations, vous avez gagné un prix !',
      ClaimNowBeforeTheRunOut: "Réclamez-les maintenant avant qu'ils ne soient épuisés !",
      ClaimPrize: 'RÉCLAMER LE PRIX',

      Levels: 'Niveaux',
      PointsAbbreviation: 'CP'
    },

    StampCampaign: {
      Config: {
        Title: 'Sélectionner le nombre de tampons',
        TotalStampsOnCard: 'Total des tampons sur la carte',
        TotalStamps: 'Total des tampons',
        StampsPerRow: 'Nombre de tampons par ligne (max 5)',
        StampsPerRowPlaceholder: '(Optionnel) Spécifier les tampons par ligne',
        StampsPerColumn: 'Nombre de tampons par colonne',
        StampsPerColumnPlaceholder: '(Optionnel) Spécifier les tampons par colonne'
      },
      TriggerConfig: {
        Title: 'Définir les règles de gain des tampons'
      },
      CardBackground: {
        Title: 'Image de la carte',
        HeaderMessage: "Message d'en-tête",
        Subheadline: 'Sous-titre',
        Backgrounds: 'Arrière-plans',
        BackgroundImage: 'Image de fond',
        RemoveImage: "Supprimer l'image",
        BrowseFiles: 'PARCOURIR LES FICHIERS',
        CardBackgroundImage: 'Image de fond de la carte',
        CardBackgroundImageAlt: 'Arrière-plan de la carte de tampons',
        ThumbnailImage: 'Image miniature',
        ThumbnailImageAlt: 'Miniature du tampon',
        Elements: 'Éléments',
        GiftActive: 'Cadeau (Actif)',
        GiftActiveAlt: 'Cadeau',
        GiftInactive: 'Cadeau (Inactif)',
        GiftInactiveAlt: 'Cadeau (Inactif)',
        StampActive: 'Tampon (Actif)',
        StampActiveAlt: 'Tampon',
        StampInactive: 'Tampon (Inactif)',
        StampInactiveAlt: 'Tampon (Inactif)',
        ButtonText: 'Texte du bouton',
        ButtonExternalLink: 'Lien externe du bouton',
        ButtonColour: 'Couleur du bouton',
        ButtonTextColour: 'Couleur du texte du bouton'
      },
      LimitConfig: {
        Title: 'Limites de tampons',
        TotalStampCards: 'Total des cartes de tampons',
        TotalStampCardsPerUser: 'Total des cartes de tampons par utilisateur',
        TotalStampsPerUser: 'Total des tampons par utilisateur',
        TotalStamps: 'Total des tampons',
        Every: 'tous les',
        Days: 'Jours',
        Months: 'Mois',
        Year: 'An',
        Weeks: 'Semaines'
      },

      AutoEnrolMechanic: {
        Title: "Mécanique d'inscription automatique",
        OperatingDays: "Jours d'activité",
        From: 'De',
        To: 'À'
      }
    },

    Referral: {
      Title: 'Types de codes de parrainage',
      CodeType: 'Type de code',
      ReferredBy: 'Parrainé par',
      SelectFile: 'Sélectionner un fichier',
      SystemGenerated: 'Généré par le système',
      AlternateId: 'ID alternatif',
      User: 'Utilisateur',
      Partner: 'Partenaire',
      ActionMechanics: "Mécaniques d'action",

      UploadSingleFileFiled: {
        AcceptedFormat: 'Formats acceptés : fichiers {{acceptedFormatsString}} uniquement',
        DownloadSample: 'Télécharger un exemple',
        ChooseFile: 'Choisir un fichier'
      }
    },

    CampaignRulesTable: {
      Outcome: 'Résultat',
      Priority: 'Priorité',
      TriggerLimitPerUser: 'Limite de déclenchement par utilisateur',
      TotalTriggerLimit: 'Limite de déclenchement totale',

      Name: 'Nom',
      CampaignPointsIssued: 'Points de campagne émis',
      Action: 'Action',
      Edit: 'Modifier',
      Remove: 'Supprimer'
    },

    RuleGroupLandingPage: {
      Title: "Page d'atterrissage",
      Headline: 'Titre principal',
      HeadlinePlaceholder: 'Veuillez saisir votre titre principal',
      SubHeadline: 'Sous-titre',
      SubHeadlinePlaceholder: 'Veuillez saisir votre sous-titre',
      BodyText: 'Texte principal',
      Image: 'Image',
      ImageHelpText: "Ratio d'aspect recommandé 16:9, 500ko max en jpg ou png",
      ExpandableContentSections: 'Sections de contenu extensibles',
      SectionLabel: 'Étiquette de la section {{index}}',
      SectionHeaderText: "Texte d'en-tête de la section {{index}}",
      SectionBodyText: 'Texte principal de la section {{index}}',

      ExpandableSection: 'Section extensible',
      Label: 'Étiquette',
      AddSection: 'Ajouter une section',
      Remove: 'Supprimer',

      ShopChooseRedeem: 'Achetez. Choisissez. Échangez.'
    },

    RuleGroupEnrolmentPage: {
      Title: "Page d'inscription",
      BodyText: 'Texte principal'
    },

    GameSettings: {
      ShakeTheTreeSettings: 'Paramètres de Shake The Tree',
      HeaderMessage: 'Message d’en-tête',
      Header: 'En-tête',
      CharactersLeft: 'caractères restants',
      HeadlineTextColour: 'Couleur du texte du titre',
      Subheadline: 'Sous-titre',
      Description: 'Description',
      GameDesign: 'Conception du jeu',
      BackgroundImage: 'Image d’arrière-plan',
      TreeImage: 'Image de l’arbre',
      GiftIcon: 'Icône du cadeau',
      GiftIconOpenState: 'Icône du cadeau – état ouvert',
      NumberOfGiftIcons: 'Nombre d’icônes de cadeaux',
      SubheadlineTextColour: 'Couleur du texte du sous-titre',
      NumberOfTaps: 'Nombre de tapes',
      PinataSettings: 'Paramètres de Pinata',
      AppBackground: 'Arrière-plan de l’application',
      FontColour: 'Couleur de la police',
      InitialPinata: 'Piñata initiale',
      CrackingPinata: 'Piñata en cours de cassage',
      BrokenPinata: 'Piñata cassée',
      ButtonText: 'Texte du bouton',
      ButtonColour: 'Couleur du bouton',
      ButtonTextColour: 'Couleur du texte du bouton',
      ClawMachineSettings: 'Paramètres du jeu',
      DummyPrizeIcon: 'Icône de prix factice (remplissage)',
      ArmAccuracy: 'Précision de la pince',
      PrizeBoxImage: 'Icône du prix',
      GameBackgroundColour: 'Couleur d’arrière-plan du jeu',
      WidescreenImage: 'Image grand écran',
      DisplayProperties: 'Propriétés d’affichage',
      Headline: 'Titre',
      AppGraphics: 'Graphismes de l’application',
      ScratchCardGraphics: 'Graphismes de la carte à gratter',
      PreScratch: 'Avant grattage',
      PostSuccess: 'Après (Succès)',
      PostFail: 'Après (Échec)',
      SubheadlineColour: 'Couleur du sous-titre',
      ScratchCardHeadline: 'Titre de la carte à gratter',
      SpinTheWheelHeadline: 'Titre de Spin The Wheel',
      SpinTheWheelGraphics: 'Graphismes de Spin The Wheel',
      RewardIcon: 'Icône de récompense',
      NumberOfWedges: 'Nombre de sections',
      NumberOfWedgesOnTheWheel: 'Nombre de sections sur la roue',
      Wedge: 'Segment',
      Color: 'Couleur',
      HasReward: 'Contient une récompense',
      RimImage: 'Image du rebord',
      WheelPosition: 'Position de la roue',
      WedgeTextColour: 'Couleur du texte du segment',

      Center: 'Centre',
      Bottom: 'Bas',
      PointerImage: 'Image du pointeur',
      PlinkoSettings: 'Paramètres de Plinko',
      Plinko: 'Plinko !',
      PlinkoGraphics: 'Graphismes de Plinko',
      FrameColour: 'Couleur du cadre',
      BallColour: 'Couleur de la balle',
      GameDuration: 'Durée du jeu',
      HowLongItTakesForTheBallToReachTheBottom:
        'Temps nécessaire pour que la balle atteigne le bas',
      Seconds: 'secondes',
      SuggestedDuration: 'Durée suggérée : 3 à 5 secondes',
      TargetType: 'Type de cible',
      Bubble: 'Bulle',
      Coins: 'Pièces',
      Stars: 'Étoiles',
      BubbleSpawnRate: 'Taux d’apparition des bulles',
      Easy: 'Facile',
      Medium: 'Moyen',
      Hard: 'Difficile',
      CTAButtonText: 'Texte du bouton CTA',
      CTAButtonColour: 'Couleur du bouton CTA',
      CTAButtonTextColour: 'Couleur du texte du bouton CTA',
      NumberOfBubbles: 'Graphismes Bubble Pop',
      BubbleLabel: 'Bulle',
      GameSettings: 'Paramètres de Bubble Pop',
      GameBackground: 'Arrière-plan du jeu',
      WedgeContents: 'Contenu du segment',
      Text: 'Texte',
      Image: 'Image',
      RewardBalance: 'Solde de récompense',
      CustomSpawnRate: "Taux d'apparition personnalisé",
      MaxBubbles: 'Max. bulles',
      SpawnInterval: "Intervalle d'apparition (en millisecondes)",
      BubblesPerSpawn: 'Bulle par apparition',
      BubbleLifetime: 'Durée de vie des bulles (en millisecondes)',
      GameDurationNote: 'REMARQUE : Une durée de jeu minimale de 10 secondes est requise.',
      MaxBubblesNote: "REMARQUE : Nombre maximal de bulles à afficher à l'écran.",
      SpawnIntervalNote: "REMARQUE : Intervalle d'apparition des bulles en millisecondes",
      BubblesPerSpawnNote: 'REMARQUE : Nombre de bulles générées simultanément.',
      BubbleLifetimeNote: 'REMARQUE : Durée de vie des bulles en millisecondes',
      Type: 'Type',
      CustomImage: 'Image personnalisée',
      SVGCode: 'Code SVG',
      DownloadSampleSVG: "Télécharger l'exemple SVG",
      Points: 'Points',
      MarkAsBonus: 'Marquer comme bonus',
      BonusImageOccurrence: "Nombre d'occurrences de Bulle bonus"
    },

    OutcomeSettings: {
      OutcomeSettings: 'Paramètres de résultat',
      WinRewardTitle: 'Titre de la récompense gagnée',
      CharactersLeft: 'caractères restants',
      WinRewardSubheadline: 'Sous-titre de la récompense gagnée',
      WinRewardGraphic: 'Graphique de la récompense gagnée',
      NoOutcomeTitle: 'Titre sans résultat',
      NoOutcomeSubheadline: 'Sous-titre sans résultat',
      NoOutcomeGraphic: 'Graphique sans résultat',
      WinRewardButton: 'Bouton de la récompense gagnée',
      NoOutcomeButton: 'Bouton sans résultat'
    },

    GameLimits: {
      GameLimits: 'Limites du jeu',
      AutoIssueMoves: 'Déplacements automatiques',
      AlwaysShowThisCampaignEvenIfOutOfGameTries:
        'Toujours afficher cette campagne même si le nombre d’essais de jeu est épuisé',
      TotalGameCampaignLimitsIs: 'La limite totale de la campagne de jeu est',
      NoteForInfiniteUsesLeaveBlank:
        'REMARQUE : pour une utilisation illimitée, laissez le champ vide.',
      IndividualUsersCanOnlyPlayThisGame:
        'Les utilisateurs individuels ne peuvent jouer à ce jeu que',
      TimesInTotal: 'fois au total',
      TimesPer: 'fois par'
    }
  },

  [CampaignReviewPageKey]: {
    GameInfoTitle: 'Informations du jeu',

    GameInfo: {
      NumberOfTaps: 'Nombre de taps :',
      NumberOfGiftsShown: "Nombre d'icônes cadeau :",
      NumberOfGiftsToDrop: "Nombre d'icônes cadeau à faire tomber :",
      CampaignLifetimeMaxMovesAvailable: 'Limites totales de la campagne de jeu :',
      AccountLifetimeMaxMovesAvailable:
        'Les utilisateurs individuels ne peuvent jouer à ce jeu que :',
      AccountIntervalMaxMovesAvailable:
        'Les utilisateurs individuels ne peuvent jouer à ce jeu que :',
      Times: 'fois',
      Per: 'par'
    },

    CampaignRequestComment: {
      Content: 'Contenu',
      DeleteButton: 'Bouton supprimer',
      Delete: 'Supprimer',
      Time: 'Temps',

      Title: 'Campagne en attente',

      Description:
        "Cette campagne est en attente d'approbation. Tous les commentaires ajoutés apparaîtront ici.",
      CommentsAdded: 'commentaires ajoutés',
      PointsExpiryUnit: 'Expiration des points (jours)',
      PointsExpiryPeriod: "Période d'expiration des points"
    },

    DeleteCommentModal: {
      SuccessMessage: 'Commentaire supprimé',
      ErrorMessage: 'Erreur lors de la suppression du commentaire',
      Title: 'Supprimer le commentaire ?',
      OkText: 'Supprimer',
      DescriptionLineOne: 'Êtes-vous sûr de vouloir supprimer ce commentaire ?',
      DescriptionLineTwo: 'Cette action ne peut pas être annulée.',
      CancelText: 'Annuler'
    },

    ApproveDenyCampaignRequestModalTitle: 'Approuver la campagne ?',
    ApproveDenyCampaignRequestModalButton: 'Approuver',

    ApproveDenyCampaignRequestModal: {
      SuccessMessage: 'La demande a été approuvée',
      ErrorMessage: 'Une erreur est survenue',
      ErrorTitle: 'Échec de l’approbation',

      ApproveTitle: 'Approuver la campagne ?',
      Title: 'Soumettre une demande de suppression ?',
      ApproveOkText: 'Approuver',
      OkText: 'Demander la suppression',
      CancelText: 'Annuler',

      ApproveDescriptionLineOne: 'Êtes-vous sûr de vouloir approuver cette campagne ?',
      ApproveDescriptionLineTwo: 'Cette action ne peut pas être annulée.',

      DescriptionLineOne:
        "Cette campagne est en attente d'approbation. Êtes-vous sûr de vouloir la supprimer ?",
      DescriptionLineTwo:
        'Une fois la suppression approuvée, cette campagne ne sera plus disponible et vous devrez la créer à nouveau.'
    },

    AddCommentModalTitle: 'Voir et ajouter des commentaires',
    AddCommentModalButton: 'Ajouter un commentaire',
    AddCommentModal: {
      SuccessMessage: 'Commentaire ajouté',
      ErrorMessage: "Erreur lors de l'ajout du commentaire",
      CancelText: 'Annuler',
      CommentInputPlaceholder: 'Saisissez votre commentaire ici',
      AddCommentButton: 'Ajouter un commentaire'
    },

    CampaignInfoTitle: 'Informations de la campagne',

    ReviewInfo: {
      Subtitle: 'Sous-titre :',
      Description: 'Description :',
      TnC: 'Conditions générales :',
      RiskDisclaimer: 'Avertissement sur les risques :',
      BranchName: 'Nom de la marque :',
      Tags: 'Tags :',
      Categories: 'Catégories :',
      Labels: 'Étiquettes :',
      Catalogue: 'Catalogues :',
      UploadImages: 'Photos téléchargées :',
      Merchant: 'Marchand :',
      CustomField: 'Champs personnalisés :',
      Type: 'Type :',
      Url: 'URL du site web :',
      Partner: 'Partenaire :',
      Reset: 'Réinitialiser :',
      Stackable: 'Cumulable :',
      Status: 'Statut :',
      Name: 'Nom de la campagne :',
      CatalogueName: 'Nom du catalogue :',
      Duration: 'Durée de la campagne :',
      StepsToRedeem: 'Étapes pour échanger :',
      ActiveAt: 'Actif à :',
      Owner: 'Propriétaire :',
      RewardLegacyAudience: 'Où cette récompense peut-elle être affichée :',
      RewardsCost: 'Coût des récompenses :',
      SellingPrice: 'Prix de vente :',

      OperatingDays: "Jours d'exploitation :",
      OperatingPeriod: "Période d'exploitation :",

      ReviewMonth: 'Mois de révision :',
      PromotionSettings: 'Paramètres de promotion :',
      DemotionSettings: 'Paramètres de rétrogradation :',
      PromoteUntil: "Promotion jusqu'au :"
    },

    SocialMediaReview: {
      CopyTextSuccessMessage: 'URL des réseaux sociaux copiée !',
      Title: 'Réseaux sociaux',
      OGTitle: 'Titre',
      OGDescription: 'Description',
      OGImage: 'Image',
      OGImageAlt: 'Aperçu réseaux sociaux',
      AlternativeIOSLinkDescription: 'Lien App iOS',
      AlternativeAndroidURLDescription: 'Lien App Android',
      OGURL: 'Lien Web',
      SocialMediaURL: 'URL réseaux sociaux',
      CopyURLButton: "Copier l'URL",
      OGURLDescription: 'Ce lien sera généré uniquement après le lancement',
      WebLink: 'Lien Web',
      Description:
        "Le champ {{webLink}} doit être rempli pour que l'URL des réseaux sociaux soit générée"
    },

    AudienceInfoTitle: "Informations sur l'audience",

    AudienceInfo: {
      Description: 'Audience sélectionnée :',
      NoListsSelected: 'Aucune liste sélectionnée',
      Include: 'Inclure',
      Exclude: 'Exclure',
      AudienceAttributes: "Attributs de l'audience",
      AudienceList: "Liste d'audience"
    },

    EnrolmentSettings: "Paramètres d'inscription",
    AutoEnrolUsers: 'Inscription automatique des utilisateurs',
    EnrollableUntil: "Inscriptible jusqu'au",
    AutoRedeemOutcome: "Résultat d'échange automatique",
    SendMicrositeNotificationAutoRedeem:
      'Envoyer une notification microsite pour le résultat auto-échangé ?',
    StampMechanics: 'Mécaniques de tampons',
    TotalStampCards: 'Total des cartes à tampons',
    TotalStampCardsPerUser: 'Total des cartes à tampons par utilisateur',
    TotalStamps: 'Total des tampons',
    TotalStampsPerUser: 'Total des tampons par utilisateur',

    GameMechanics: {
      Title: 'Mécaniques de jeu',
      HitThePinata: {
        Title: 'Frappez la Piñata',
        InstructionsLineOne:
          "1. L'utilisateur final obtient une récompense en accomplissant une action requise, dans ce cas en frappant la piñata.",
        InstructionsLineTwo:
          '2. Les récompenses sont distribuées aléatoirement selon la probabilité définie sur les récompenses',
        IdealFor: 'Idéal pour',
        InstructionsLineThree: '1. Jeu saisonnier',
        HeaderMessage: "Message d'en-tête",
        GameDesign: 'Design du jeu',
        PlayButtonText: 'Texte du bouton jouer'
      },

      ShakeTheTree: {
        Title: "Secouez l'arbre",
        InstructionsLineOne:
          'Engagez les clients avec un défi qui nécessite de secouer le téléphone',
        GameMechanics: 'Mécaniques de jeu',
        InstructionsLineTwo:
          "1. L'utilisateur final obtient une récompense en accomplissant une action requise, dans ce cas en frappant la piñata",
        InstructionsLineThree:
          '2. Les récompenses sont distribuées aléatoirement selon la probabilité définie sur les récompenses',
        IdealFor: 'Idéal pour',
        InstructionsLineFour: '1. Jeu saisonnier',
        HeaderMessage: "Message d'en-tête",
        GameDesign: 'Design du jeu',
        TreeVisual: "Visuel de l'arbre",
        GiftVisual: 'Visuel du cadeau',
        PlayButtonText: 'Texte du bouton jouer'
      },

      BubblePop: {
        Title: 'Propriétés Bubble Pop',
        GameTitle: 'Jeu Bubble Pop',
        Description: 'Engagez le client avec ses compétences.',
        BubbleSpawnRate: "Taux d'apparition des bulles",
        GameDuration: 'Durée du jeu',
        Seconds: 'secondes',
        GameBackground: 'Arrière-plan du jeu',
        NumberOfBubbles: 'Nombre de bulles',
        BubbleColors: 'Couleurs des bulles',
        Bubble: 'Bulle',
        CustomImage: 'Image personnalisée',
        Points: 'Points',
        IsBonus: 'est bonus ?',
        Yes: 'Oui',
        No: 'Non',
        MaxBubbles: 'max. bulles',
        SpawnInterval: "intervalle d'apparition (en millisecondes)",
        BubblesPerSpawn: 'Bulles par apparition',
        BubbleLifetime: 'Durée de vie des bulles (en millisecondes)',
        CustomSpawnRate: "Taux d'apparition personnalisé"
      },

      QuizOrSurveyTypeGame: {
        Properties: 'Propriétés',

        GameMeta: {
          ScratchCard: 'Carte à gratter',
          ScratchCardDetails:
            'Engagez les clients avec un défi qui nécessite de gratter une carte de jeu.',
          HitThePinata: 'Frappez la Piñata',
          HitThePinataDetails:
            'Engagez les clients avec un défi qui nécessite de secouer le téléphone.',
          ShakeTheTree: "Secouez l'arbre",
          ShakeTheTreeDetails:
            "Engagez les clients avec un défi qui nécessite de taper sur l'objet.",
          SpinTheWheel: 'Tournez la roue',
          SpinTheWheelDetails: 'Engagez le client avec une roue de la fortune.',
          Plinko: 'Plinko',
          PlinkoDetails: 'Faites tomber la balle et obtenez des rebonds chanceux',
          ClawMachine: 'Machine à griffes',
          ClawMachineDetails:
            'Engagez les clients avec une griffe qu’ils positionnent au-dessus d’un prix et abaissent pour l’attraper.',
          ArmAccuracy: 'Précision de la pince',
          PrizeMode: 'Mode de jeu',
          FixedPrizeMode: 'Les clients attrapent un prix fixe',
          RandomPrizeMode: 'Le client obtient un prix aléatoire (blindbox)'
        },

        GameGraphics: {
          AppGraphics: "Graphiques de l'application",
          PreScratch: 'pré-grattage',
          PostSuccess: 'Post (succès)',
          PostFail: 'Post (échec)',
          RewardIcon: 'Icône de récompense',
          NumberOfWedges: 'Nombre de segments',
          WedgeColors: 'Couleurs des segments',
          Wedge: 'Segment',
          WheelImage: 'Image de la roue',
          WheelPosition: 'Position de la roue',
          PointerImage: 'Image du pointeur',
          Headline: 'Titre',
          Subheadline: 'Sous-titre',
          AppBackground: "Arrière-plan de l'application",
          ButtonText: 'Texte du bouton',

          FrameColor: 'Couleur du cadre',
          BallColor: 'Couleur de la balle',
          HeadlineTextColor: 'Couleur du texte du titre',
          SubheadlineTextColour: 'Couleur du texte du sous-titre',

          GameBackgroundColour: 'Couleur d’arrière-plan du jeu',
          ButtonColour: 'Couleur du bouton',
          ButtonTextColour: 'Couleur du texte du bouton',
          PrizeBoxImage: 'Image de la boîte à prix',
          PrizeIcons: 'Icônes des prix',
          PrizeIconSlot: 'Emplacement'
        },

        Survey: 'Sondage',
        SurveyDetails: 'Engagez le client avec des questions à choix multiples.',
        Quiz: 'Quiz',
        QuizDetails: 'Engagez le client avec des questions à choix multiples.',
        BackgroundImage: 'Image de fond',
        Submit: 'Soumettre'
      }
    },

    RewardLimits: {
      Title: 'Limites de récompenses',
      DescriptionLineOne: 'Nombre total de récompenses pouvant être émises :',
      DescriptionLineTwo: 'Nombre de récompenses que chaque utilisateur peut recevoir :',
      DescriptionLineThree: 'Les utilisateurs individuels ne peuvent jouer à ce jeu que :',
      DescriptionLineFour: "La campagne n'émettra des récompenses que :",
      InTotal: 'au total',
      Times: 'fois',
      Per: 'par'
    },

    Rules: 'Règles',

    RulePreview: {
      MoreOutcomes: '+{{count}} résultat(s) supplémentaire(s)',
      ID: 'ID',
      RulesBalance: 'Équilibre des règles',
      Of: 'de',
      Trigger: 'Déclencheur',
      Type: 'Type',
      Conditions: 'Conditions',
      EventName: "Nom de l'événement",
      CampaignId: 'ID de campagne',
      RewardId: 'ID de récompense',
      LoyaltyId: 'ID de fidélité',
      LoyaltyTierId: 'ID de niveau de fidélité',
      AutomationTriggerId: "ID de déclencheur d'automatisation",
      Outcome: 'Résultat',
      NumberOfStamps: 'Nombre de tampons',
      AwardPoints: 'Points attribués',
      ForEveryCurrency: 'Pour chaque devise',
      UpToAMaximumOfPoints: "Jusqu'à un maximum de points",
      UserEarnsOneRaffleTicket: "L'utilisateur gagne 1 ticket de tirage au sort",
      UserEarnsRaffleTickets: "L'utilisateur gagne {{x}} ticket(s) de tombola",
      AwardRaffleTickets: 'Attribuer {{x}} ticket(s) de tombola',
      UpToAMaximumOfRaffleTickets: "Jusqu'à {{z}} ticket(s) de tombola maximum",
      TheTaskWillBeMarkedAsDone: 'La tâche sera marquée comme "terminée"',
      Points: 'Points',
      LoyaltyProgram: 'Programme de fidélité',
      Award: 'Récompense',
      GlAccountNumber: 'Numéro de compte GL',
      GlAccountName: 'Nom du compte GL',
      CostCenterId: 'ID du centre de coût',
      BranchCode: "Code de l'agence",
      Reward: 'Récompense',
      Name: 'Nom',
      SellingFrom: 'Vente à partir de',
      Limits: 'Limites',
      MaximumEvents: 'Événements maximum',
      PerCampaign: 'par campagne',
      PerUser: 'par utilisateur',
      TriggerRateLimit: 'Limite de taux de déclenchement',
      PerUserForEvery: 'par utilisateur pour chaque',
      SendPushNotificationLabel:
        'Faut-il envoyer une notification push pour chaque déclenchement de règle?:',
      Attribute: 'Attribut',
      Operator: 'Opérateur',
      SelectedValues: 'Valeurs sélectionnées',
      Conditionals: 'Conditionnels',
      Condition: 'Condition',
      NA: 'N.D.',
      PushNotificationRuleForInstantOutcomeTransactionIssue:
        'Règle de notification push pour émission de transaction à résultat instantané',
      PushNotificationRuleForAutoRedeemInstantOutcomeTriggers:
        'Règle de notification push pour les déclencheurs de résultat instantané à échange automatique',
      CurrencyWithin1: 'devise dans 1',
      UserMustPerform: "L'utilisateur doit effectuer",
      UserMust: "L'utilisateur doit",
      AtLeast: 'au moins',
      TimesWithin1: 'fois dans 1',
      StreakCampaignMechanics: 'Mécanique de campagne en série',
      SendPushNotificationForEveryRuleTrigger:
        'Envoyer une notification push pour chaque déclencheur de règle ?:',
      YES: 'OUI',
      NO: 'NON',
      MediaTag: 'Balise média :',
      CustomFields: 'Champs personnalisés :',
      StreakTarget: 'Objectif de série',
      TargetCriteria: 'Critères de l’objectif',
      StreakPeriod: 'Période de série',
      Within: 'dans',
      TransactionsWithin: 'transactions dans'
    },

    ActionMechanics: "Mécaniques d'action",

    InstantRewardMechanics: 'Mécaniques de récompense instantanée',
    InstantRewardMechanicsLabel:
      "Afficher la campagne dans la liste des campagnes de l'utilisateur ?",
    IssuanceLimits: "Limites d'émission",
    IssuanceLimitsLabel: "Nombre total d'événements d'émission de prix (au niveau de la campagne)",
    AccountLifetimeMaxAvailableLabel:
      "Nombre total d'événements d'émission de prix (par utilisateur)",
    RateLimitCampaignLabel: 'Limite de taux (au niveau de la campagne)',
    RateLimitUserLabel: 'Limite de taux (par utilisateur)',
    Outcomes: 'Résultats',
    IssuePrizeEvents: "événement(s) d'émission de prix",
    LimitTo: 'Limiter à',
    ForEvery: 'pour chaque',

    PrizeSet: {
      Outcomes: 'résultats',
      PrizesOutcomes: 'Gains et résultats',
      WedgeOutcome: 'Résultat de la section',
      QuizSelectableOne: 'Attribuer des prix pour avoir terminé le quiz',
      QuizSelectableTwo: 'Attribuer des points par réponse correcte',
      PointsPerAnswerLabel: 'Points par réponse correcte :',
      Points: 'points',
      Edit: 'Modifier',
      Remove: 'Supprimer',
      ChangeReward: 'Changer la récompense',
      ChangeBadge: 'Changer le badge',
      ChangePoints: 'Changer les points',
      NoPrizeAdded: 'Aucun prix ajouté',
      Prizes: 'Prix',
      AddRandomPrize: 'Ajouter un prix aléatoire',
      AddPrizeSet: 'Ajouter un ensemble de prix',
      AddRewards: 'Ajouter des récompenses',
      AwardPoints: 'Attribuer des points',
      AwardBadges: 'Attribuer des badges',
      AddPrize: 'Ajouter un prix',
      IncludeNoPrizeAsOutcome: 'Inclure aucun prix comme résultat',

      GLACDetail: 'Détail du compte GL',
      GLACNo: 'N° de compte GL',
      GLACName: 'Nom du compte GL',
      GLACType: 'Type de compte GL',
      CostCenterID: 'ID du centre de coût',
      BranchCode: "Code de l'agence",

      WinOdds: 'Probabilité de gain',
      Prize: 'Prix',
      Merchant: 'Marchand',
      Balance: 'Solde',
      PrizeIcon: 'Icône',

      GameTry: 'Essai de jeu',
      GameTryCampaignSelectWarningText:
        "Seules les campagnes avec l'émission automatique d'essais de jeu désactivée peuvent être sélectionnées pour émettre des essais de jeu.",
      GameTryCampaignID: "ID de la campagne d'essai de jeu : {{campaignId}}",
      NumberofGameTries: "Nombre d'essais de jeu",
      NoOutcome: 'Aucun résultat',
      Reward: 'Récompense',
      LoyaltyPoints: 'Points de fidélité',
      Badge: 'Badge',
      PrizeSet: 'Ensemble de prix',
      Quantity: 'Quantité',
      NoPrize: 'Pas de gain'
    },

    PrizePerAnswer: {
      CountOfPointsValidationMessage: 'Veuillez spécifier un nombre de points par réponse',
      LoyaltyProgramValidationMessage: 'Veuillez sélectionner un programme de fidélité',
      Title: 'Points par réponse correcte',
      OkText: 'Enregistrer',
      CancelText: 'Annuler',
      LoyaltyProgramLabel: 'Sélectionner un programme de fidélité',
      LoyaltyProgramSelectPlaceholder: 'Sélectionner un programme de fidélité',
      CountOfPointsLabel: 'Attribuer'
    },

    RewardSelectModal: {
      Title: 'Sélectionner une récompense',
      OkText: 'Ajouter une récompense',
      CancelText: 'Annuler',
      SearchPlaceholder: 'Trouver une récompense par nom, id ou marchand',
      ID: 'ID',

      Tabs: {
        All: 'Tout',
        Active: 'Actif',
        Approved: 'Approuvé',
        Private: 'Privé',
        System: 'Système'
      },

      Reward: 'Récompense',
      Merchant: 'Marchand',
      Balance: 'Solde',
      SellingFrom: 'Vente à partir de',
      SellingTo: "Vente jusqu'à"
    },

    IssuePointsModal: {
      ShowVariablePointsValidationMessage: 'Veuillez spécifier un nombre de points',
      LoyaltyProgramValidationMessage: 'Veuillez spécifier un programme de fidélité',
      ShowVariablePointsOutcomeValidatioMessage: 'Ce champ est obligatoire',
      GLAccountTypeValidationMessage: 'Veuillez sélectionner un type de compte GL',
      GLAccountNameValidationMessage: 'Veuillez sélectionner un nom de compte GL',
      GLAccountIDValidationMessage: 'Veuillez sélectionner un compte GL',

      PleaseEnterAGreaterThanZero: 'Veuillez entrer une valeur supérieure à 0.',
      PleaseSpecifyTheNumberOfDays: 'Veuillez spécifier le nombre de jours.',
      DaysMustBeAtLeastOne: 'Le nombre de jours doit être au moins égal à 1.',
      AwardedPointsExpireIn: 'Les points attribués expirent dans',
      NumberOfDaysToExpirePlaceholder: 'ex. 7',
      Days: 'jours',

      FixedPoints: 'Points fixes',
      VariablePoints: 'Points variables',

      IssuePoints: 'Émettre des points',
      Save: 'Enregistrer',
      Cancel: 'Annuler',
      SelectLoyaltyProgramLabel: 'Sélectionner un programme de fidélité',
      ShowVariablePointsAlertMessage:
        "Vous pouvez attribuer soit des points fixes, soit des points variables. Pour les points variables, la dernière transaction de l'utilisateur sera prise en compte.",
      NumberOfPointsToAward: 'Nombre de points à attribuer',
      NumberOfPointsToAwardPlaceholder: 'ex. 10',
      SelectGLAccount: 'Sélectionner un compte GL',
      SelectGLAccountPlaceholder: 'Sélectionner un compte GL',
      GLAccountType: 'Type de compte GL',
      GLAccountTypePlaceholder: 'Type de compte GL',
      GLAccountName: 'Nom du compte GL',
      GLAccountNamePlaceholder: 'Nom du compte GL',

      AwardedPointsExpire: 'Les points attribués expirent',
      AfterXDays: 'après',
      OnCampaignEndDate: 'à la date de fin de la campagne',
      OnASpecificDate: 'à une date spécifique',
      CampaignEndDateNotSet: 'La campagne doit avoir une date de fin pour utiliser cette option.',
      CampaignEndDateRequired:
        "Erreur : Une date de fin de campagne est requise. Veuillez définir une date de fin ou désactiver l'option d'expiration « À la date de fin de la campagne ».",
      PointsWillExpireOnEndDate:
        'Les points expireront le {{date}} à la date de fin de la campagne.',
      SelectExpiryDateTime: "Sélectionner la date et l'heure d'expiration",
      PleaseSelectExpiryMode: "Veuillez sélectionner une option d'expiration.",
      PleaseSelectAnExpiryDate: "Veuillez sélectionner une date d'expiration.",
      PleaseSelectAnExpiryTime: "Veuillez sélectionner une heure d'expiration.",
      ExpiryDateMustBeInTheFuture: "La date d'expiration doit être dans le futur.",
      AwardedPointsExpireOnCampaignEndDate:
        'Les points attribués expirent à la date de fin de la campagne',
      AwardedPointsExpireOn: 'Les points attribués expirent le',
      OnCampaignEndDateSuffix: 'à la date de fin de la campagne'
    },

    VariablePointsPane: {
      Transaction: 'Transaction',
      Award: 'Attribuer',
      Every: 'Chaque',
      UpToAMaximumAmountOf: "Jusqu'à un montant maximum de"
    },

    BadgeSelectModal: {
      Title: 'Sélectionner un badge à afficher',
      OkText: 'Ajouter un badge',
      CancelText: 'Annuler'
    },

    BadgeListTable: {
      Name: 'Nom',
      StartDate: 'Date de début',
      EndDate: 'Date de fin',
      Actions: 'Actions',
      ID: 'ID',
      SearchBadgesPlaceholder: 'Rechercher des badges',
      Edit: 'Modifier',
      Deactivate: 'Désactiver',
      Activate: 'Activer',
      ErrorSortingBadgeMessage: 'Erreur lors du tri du badge.',
      ErrorUpdatingBadgeStateMessage: "Erreur lors de la mise à jour de l'état du badge",
      Status: 'Statut'
    },

    ReviewOutcomesDisplay: {
      IncludeNoOutcome: 'Inclure aucun résultat',
      All: 'Tout',
      Active: 'Actif',
      Approved: 'Approuvé',
      Inactive: 'Inactif',
      Ended: 'Terminé',
      Private: 'Privé',
      Points: 'Points',
      Custom: 'Personnalisé'
    },

    StampCampaignOutcomes: {
      GLAccountNo: 'N° de compte GL',
      GLAccountName: 'Nom du compte GL',
      CostCenterID: 'ID du centre de coût',
      GLAccountDetail: 'Détail du compte GL',

      Slot: 'Emplacement',
      OutcomeType: 'Type de résultat',
      AddRewards: 'Ajouter des récompenses',
      AwardPoints: 'Attribuer des points',
      AwardBadges: 'Attribuer des badges',
      AddPrizeToSet: "Ajouter un prix à l'ensemble",
      IncludeNoPrizeAsOutcome: 'Inclure aucun prix comme résultat',
      AddAnotherReward: 'Ajouter une autre récompense',
      AddAnotherBadge: 'Ajouter un autre badge',
      RewardName: 'Nom de la récompense',
      NumberOfPoints: 'Nombre de points',
      ID: 'ID',
      Reward: 'Récompense',
      Action: 'Action',
      Delete: 'Supprimer',
      NoOutcome: 'Aucun résultat',
      ChangeByAddingReward: 'modifier en ajoutant une récompense',
      AddFixedPrizeSet: 'Ajouter un ensemble de prix fixe',
      AddRandomPrize: 'Ajouter un prix aléatoire',
      IssueReward: 'Émettre une récompense',
      IssuePoints: 'Émettre des points',
      IssueBadges: 'Émettre des badges',
      AwardGameTry: 'Attribuer des tentatives de jeu',
      SlotsWithOutcomeAdded: 'Emplacements avec résultat ajouté',
      PleaseEnterPrizeTitle: 'Veuillez saisir le titre du prix',
      PrizeTitleRequired: 'Le titre du prix est requis'
    },

    OutcomeSettings: {
      Title: 'Paramètres des résultats',
      PrizeSet: 'Ensemble de prix',
      Submit: 'Soumettre',
      MixedRewardsButtonText: 'Texte du bouton basé sur la première récompense listée',
      Headline: 'Titre'
    },

    GameOutcomeScreens: {
      QuizScreens: 'Écrans du quiz',
      SurveyScreens: 'Écrans du sondage',
      LandingPage: "Page d'accueil",
      LandingScreenHeading: "Titre de l'écran d'accueil",
      LandingScreenSubheading: "Sous-titre de l'écran d'accueil",
      LandingScreenButtonText: "Texte du bouton de l'écran d'accueil",
      LandingScreenText: "Texte de l'écran d'accueil",
      OutcomeScreen: 'Écran des résultats',
      SuccessfulOutcomeImage: 'Image de résultat réussi',
      SuccessfulOutcomeMessage: 'message de résultat réussi',
      SuccessfulOutcomeButton: 'bouton de résultat réussi',
      NoOutcomeMessage: 'message sans résultat',
      NoOutcomeButton: 'bouton sans résultat',
      NoOutcomeGraphic: 'Graphique sans résultat',
      OutcomeScreens: 'Écrans des résultats',
      WinRewardGraphic: 'Graphique de récompense gagnée',
      WinRewardMessage: 'Message de récompense gagnée',
      WinRewardButton: 'Bouton de récompense gagnée'
    },

    TeamMechanics: "Mécaniques d'équipe",
    MemberPerTeam: 'Membre par équipe',
    DisplaySetup: "Configuration de l'affichage",
    LandingPage: "Page d'accueil",
    PreEnrolmentMessage: 'Message pré-inscription',
    StampsEarnMessage: 'Message de gain de tampons',
    JoinTeamPagePreview: {
      Title: 'Rejoindre une équipe',
      ButtonText: "Rejoindre l'équipe",
      InputPlaceholder: "Code d'équipe"
    },
    JoinTeamPage: "Page pour rejoindre l'équipe",
    JoinTeamInfoMessage: "Message d'information pour rejoindre l'équipe",
    InviteMemberMessage: "Message d'invitation de membre",
    InviteMemberMessageDescription: "Description du message d'invitation de membre",
    InviteMemberMessageBlurb: "Texte du message d'invitation de membre",

    QuestMechanics: 'Mécaniques de quête',
    UserTriesValidity: 'Validité des essais utilisateur',
    Task: 'Tâche',
    QuestTask: {
      AddRule: 'Ajouter une règle',
      Required: '*obligatoire'
    },
    TotalQuests: 'Nombre total de quêtes pouvant être démarrées dans une campagne',
    TotalQuestsPerUser: 'Nombre total de quêtes pouvant être démarrées par chaque utilisateur',
    DisplaySetItup: "Configurer l'affichage",

    CampaignRuleFormModal: {
      Title: 'Règle de campagne',
      RuleName: 'Nom de la règle',
      Priority: 'Priorité',
      Outcome: 'Résultat',
      Edit: 'Modifier',
      Create: 'Créer',
      Update: 'Mettre à jour',
      Add: 'Ajouter',
      CancelText: 'Annuler',
      RequiredErrorMessage: 'Ce champ est obligatoire.',
      OutcomeRewardRequiredErrorMessage: 'Veuillez sélectionner une récompense',
      OutcomePointsRequiredErrorMessage: 'Veuillez sélectionner un programme de fidélité',
      GLAccountTypeRequiredErrorMessage: 'Veuillez sélectionner un type de compte GL',
      GLAccountNameRequiredErrorMessage: 'Veuillez sélectionner un nom de compte GL',
      OutcomeRequiredErrorMessage: 'Ce champ est obligatoire',
      StampsWillBeIssued: 'Le(s) tampon(s) sera/seront émis',
      FixedPoints: 'Points fixes',
      VariablePoints: 'Points variables',
      EarnType: 'Type de gain',
      Award: 'RÉCOMPENSE',
      Points: 'points',
      ForEvery: 'POUR CHAQUE',
      Currency: 'Devise',
      UpToAMaximumOf: "JUSQU'À UN MAXIMUM DE",
      QuestOutcomeSegment: 'La tâche sera marquée comme "terminée"',
      InviteOutcomeSegment: 'La tâche sera marquée comme "terminée"',
      RaffleOutcomeSegment: "L'utilisateur gagnera un ticket de tombola",
      FixedRaffleTickets: 'Tickets de tombola fixes',
      VariableRaffleTickets: 'Tickets de tombola variables',
      RaffleTicketQuantitySuffix: 'Ticket(s) de tombola',
      RaffleTicketQuantityPlaceholder: 'ex. {{n}}',
      SelectOutcomeType: 'Sélectionner le type de résultat',
      Reward: 'Récompense',
      ChangeReward: 'Modifier la récompense',
      SelectReward: 'Sélectionner une récompense',
      SelectLoyaltyProgram: 'Sélectionner un programme de fidélité',
      NumberOfPoints: 'Nombre de points',
      SelectGLAccount: 'Sélectionner un compte GL',
      GLAccountType: 'Type de compte GL',
      GLAccountTypePlaceholder: 'type',
      GLAccountName: 'Nom du compte GL',
      GLAccountNamePlaceholder: 'nom',
      ValidityPeriod: 'Période de validité',

      ValidationMessages: {
        PleaseSelectATriggerEvent: 'Veuillez sélectionner un événement déclencheur',
        PleaseSelectALoyaltyProgramValue:
          'Veuillez sélectionner une valeur de programme de fidélité',
        PleaseSelectALoyaltyTierValue: 'Veuillez sélectionner un niveau de fidélité',
        PleaseSelectACampaign: 'Veuillez sélectionner une campagne',
        PleaseSelectAStampCampaign: 'Veuillez sélectionner une campagne de tampons',
        PleaseEnterTheNumberOfStamps: 'Veuillez saisir le nombre de tampons',
        NumberOfStampsMustBeAtLeastOne: 'Le nombre de tampons doit être au moins 1',
        StampPositionMustBeAtLeastOne: 'La position du tampon doit être au moins 1',
        PleaseEnterTheStampPosition: 'Veuillez saisir la position du tampon',
        PleaseSelectAnAutomationTrigger: 'Veuillez sélectionner un déclencheur d’automatisation',
        IntervalCannotBeLessThanZero: "L'intervalle ne peut pas être inférieur à zéro",
        IntervalCannotBeGreaterThan365: "L'intervalle ne peut pas être supérieur à 365",
        PleaseEnterTheInterval: "Veuillez saisir l'intervalle",
        PleaseSelectAMilestone: 'Veuillez sélectionner une étape',
        PleaseSelectARule: 'Veuillez sélectionner une règle',
        PleaseSelectAReward: 'Veuillez sélectionner une récompense',
        ThisFieldIsRequired: 'Ce champ est requis',
        TheFieldIsRequired: 'Le champ est requis',

        AttributeIsRequired: "L'attribut est requis",
        OperatorIsRequired: "L'opérateur est requis",
        PleaseSelectAtLeastOneDay: 'Veuillez sélectionner au moins un jour',
        PleaseSelectATime: 'Veuillez sélectionner une heure',
        FromTimeMustBeLessThanToTime: "L'heure de début doit être inférieure à l'heure de fin",
        PleaseSelectAFormTime: 'Veuillez sélectionner une heure de début',
        PleaseSelectAnToTime: 'Veuillez sélectionner une heure de fin',
        PleaseConfigureTheRuleTriggerDays:
          'Veuillez configurer les jours de déclenchement de la règle',

        PleaseConfigureTheTrigger: 'Veuillez configurer le déclencheur',
        PleaseFillInTheNameOfTheRule: 'Veuillez renseigner le nom de la règle',
        PleaseSelectAnOwner: 'Veuillez sélectionner un propriétaire',
        PleaseSelectATriggerRule: 'Veuillez sélectionner une règle de déclenchement',
        PleaseSpecifyAStartTime: 'Veuillez spécifier une heure de début',
        PleaseSpecifyAValidEndTime: 'Veuillez spécifier une heure de fin valide',
        PleaseSelectAnOutcomeType: 'Veuillez sélectionner un type de résultat',
        PleaseSelectAMediaTag: 'Veuillez sélectionner une étiquette média',
        PleaseSelectAGLAccountType: 'Veuillez sélectionner un type de compte GL',
        PleaseSelectAGLAccountName: 'Veuillez sélectionner un nom de compte GL',
        GLAccountIDIsRequired: "L'identifiant du compte GL est requis",
        PleaseEnterAKey: 'Veuillez saisir une clé',
        AtLeastOneOutcomePropertyIsRequired: 'Au moins une propriété de résultat est requise',
        OutcomePropertiesAreRequired: 'Les propriétés de résultat sont requises',
        ValueMustBeGreaterThanZero: 'La valeur doit être supérieure à zéro.',
        ValueCannotBeZero: 'La valeur ne peut pas être zéro.',
        PleaseEnterANumber: 'Veuillez saisir un nombre',
        PleaseEnterAWholeNumber: 'Veuillez saisir un nombre entier',
        NumberMustBeAPositiveNumber: 'Le nombre doit être un nombre positif',
        EnterAWholeNumber: 'Saisissez un nombre entier',

        OutcomeRequiredErrorMessage: 'Ce champ est requis',
        OutcomePointsRequiredErrorMessage: 'Veuillez sélectionner un programme de fidélité'
      }
    },

    SelectTriggerSection: {
      SelectATrigger: 'Sélectionner un déclencheur',
      Custom: 'Personnalisé',
      Transaction: 'Transaction',
      Loyalty: 'Fidélité',
      Campaign: 'Campagne',
      Customer: 'Client',
      Reward: 'Récompense',
      Location: 'Localisation',
      SelectTrigger: 'Sélectionner un déclencheur',
      SelectATriggerPlaceholder: 'Veuillez sélectionner un déclencheur',
      Others: 'Personnalisé',
      LoyaltyTrigger: {
        HelpText:
          "Le nombre de points sur le point d'expirer sera vérifié au début de chaque cycle de révision.",
        AchievedNextTier: 'Niveau suivant atteint',
        TenPercentCloseToNextTier: '10% proche du niveau suivant',
        PointsIssued: 'Points émis',
        AgeingPoints: "Points vieillissants (points sur le point d'expirer dans le cycle actuel)",
        SelectLoyaltyProgram: 'Sélectionner un programme de fidélité',
        SelectNextTier: 'Sélectionner le niveau suivant',
        SelectNextTierPlaceholder: 'Veuillez sélectionner un niveau de fidélité'
      },
      RewardTrigger: {
        RedeemReward: 'Échanger une récompense',
        IssueReward: 'Émettre une récompense',
        IssueRewardFromCampaign: 'Émettre une récompense depuis la campagne',
        IssueRewardFromMerchant: 'Émettre une récompense depuis le marchand',
        VoucherForParticularRewardExpiringIn: 'Bon pour une récompense particulière expirant dans',
        AnyVoucherExpiringIn: 'Tout bon expirant dans {{days}}'
      },

      MilestoneTrigger: {
        StampRedeemed: 'Tampon échangé',
        StampsIssued: 'Tampons émis',
        StampsInactive: 'Tampons inactifs',
        GamePlayed: 'Jeu joué',
        GameTryIssued: 'Essai de jeu émis',
        CampaignEnrolled: 'Inscrit à la campagne',
        CampaignCompleted: 'Campagne terminée',
        CampaignNotCompleted: 'Campagne non terminée',
        ProgressLevelAchieved: 'Niveau de progression atteint',
        ProgressRuleTriggered: 'Règle de progression déclenchée',
        QuestTaskCompleted: 'Tâche de quête terminée',

        SelectAStampCampaign: 'Sélectionner une campagne de tampons',
        Change: 'Modifier',
        Select: 'Sélectionner',
        Stamp: 'Tampon',
        Campaign: 'Campagne',
        ID: 'ID',
        FooterMsg:
          'Toute récompense {{isCampaignRewardsSelected}} dans cette campagne sera un déclencheur',
        SelectStampsSlot: 'Sélectionner un emplacement de tampons',
        StampCardPosition: 'Position de la carte de tampons'
      },

      CustomerTrigger: {
        SignUp: 'Inscription',
        SignIn: 'Connexion',
        ProfileUpdated: 'Profil mis à jour'
      },

      TransactionTrigger: {
        SelectATriggerPlaceholder: 'Choisir un...',
        FromDate: 'Date de début',
        ToDate: 'Date de fin',
        SelectOperator: 'Sélectionner un opérateur',
        PropertyDataType: 'Type de données de propriété',
        Key: 'Clé',
        Operator: 'Opérateur',
        Sunday: 'Dimanche',
        Monday: 'Lundi',
        Tuesday: 'Mardi',
        Wednesday: 'Mercredi',
        Thursday: 'Jeudi',
        Friday: 'Vendredi',
        Saturday: 'Samedi',
        Value: 'Valeur',
        PleaseSeparateMultipleValuesUsingComma:
          'Veuillez séparer les valeurs multiples par des virgules',
        SelectTrigger: 'Sélectionner un déclencheur',
        And: 'Et',
        AddCondition: 'Ajouter une condition'
      },

      LocationTrigger: {
        EnterLocationDetails: 'Saisir les détails de localisation',
        Latitude: 'Latitude',
        Longitude: 'Longitude',
        LatitudeDegrees: 'Degrés (-90.0 à 90.0)',
        LongitudeDegrees: 'Degrés (-180.0 à 180.0)',
        PermissibleRadius: 'Rayon autorisé (en mètres)',
        Radius: 'Rayon autorisé',
        Preview: 'APERÇU'
      },

      CampaignSelectField: {
        Interval: 'Intervalle',
        Days: '(Jours)',
        SelectAStampCampaign: 'Sélectionner une campagne de tampons',
        Change: 'Modifier',
        Select: 'Sélectionner',
        Stamp: 'Tampon',
        SelectACampaign: 'Sélectionner une campagne',
        Edit: 'Modifier',
        Add: 'Ajouter',
        Campaign: 'Campagne',
        SelectAMilestone: 'Sélectionner une étape',
        SelectARule: 'Sélectionner une règle',
        SelectATask: 'Sélectionner une tâche'
      },

      GameSelectField: {
        SelectAGameCampaign: 'Sélectionner une campagne de jeu',
        Game: 'Jeu',
        Campaign: 'Campagne',
        Change: 'Modifier',
        Select: 'Sélectionner'
      },

      CampaignRewardSelectField: {
        SelectACampaign: 'Sélectionner une campagne',
        Change: 'Modifier',
        Select: 'Sélectionner',
        Campaign: 'Campagne',
        SelectAReward: 'Sélectionner une récompense (Optionnel)',
        Reward: 'Récompense'
      },

      MerchantRewardSelectField: {
        SelectAMerchant: 'Sélectionner un marchand',
        Change: 'Modifier',
        Select: 'Sélectionner',
        Merchant: 'Marchand',
        AddMerchant: 'Ajouter un marchand',
        Cancel: 'Annuler',
        SearchMerchant: 'Rechercher un marchand par nom ou ID',
        Active: 'Actif',
        Inactive: 'Inactif'
      },

      RewardSelectField: {
        SelectAReward: 'Sélectionner une récompense (Optionnel)',
        Change: 'Modifier',
        Reward: 'Récompense',
        Select: 'Sélectionner',
        WarningText:
          "Le type de résultat est limité à [Push Event] lorsqu'une récompense système est sélectionnée"
      },

      RewardExpirySetupField: {
        SelectAReward: 'Sélectionner une récompense',
        Change: 'Modifier',
        Select: 'Sélectionner',
        Reward: 'Récompense',
        Periods: 'Périodes (Jours)'
      }
    },

    RuleTriggerLimitSegment: {
      Title: 'Limites de déclenchement :',
      TotalTriggerEvents: "Nombre total d'événements de déclenchement (au niveau de la campagne)",
      TotalTriggerEventsPerUser: "Nombre total d'événements de déclenchement (par utilisateur)",
      TriggerRateLimitPerUser: 'Limite de taux de déclenchement (par utilisateur)',
      LeaveTheLimitFieldsBlankForUnlimitedTriggerEvents:
        '- Laissez les champs de limite vides pour des événements de déclenchement illimités -',
      Days: 'Jours',
      Weeks: 'Semaines',
      Months: 'Mois',
      Years: 'Années',
      TriggerEventForEvery: 'événement(s) de déclenchement pour chaque',
      AccountIntervalLimitPlaceholder: 'ex. 2',
      AccountIntervalUnitsPlaceholder: 'ex. 1',
      TriggerLimitPlaceholder: '∞',
      TriggerAccountLimitPlaceholder: '∞',
      LimitTo: 'Limiter à'
    },

    RuleAudience: {
      SelectFilters: 'Sélectionner des filtres',
      Age: 'Âge',
      Gender: 'Genre',
      Location: 'Localisation',
      Language: 'Langue',
      Device: 'Appareil',
      Browser: 'Navigateur',
      Customs: 'Personnalisés',
      Ethnicity: 'Ethnicité',
      Loyalty: 'Fidélité',
      EmailTags: "Tags d'email",
      BirthMonth: 'Mois de naissance',
      NoFiltersSelected: 'Aucun filtre sélectionné',
      SelectedFilters: 'Filtres sélectionnés'
    },

    LoyaltyTier: {
      Includes: 'inclut',
      UsersWhoAchieved: 'Utilisateurs qui ont atteint',
      SelectProgramAndTier: 'Sélectionner le programme et le niveau'
    },

    LevelsAndPrizes: 'Niveaux et prix',

    LevelWrapper: {
      ValidatePointHelpMessage:
        'Les points du niveau {{level}} doivent être supérieurs aux points du niveau {{previousLevel}} !',
      LevelTitle: 'Affichage du niveau {{level}}',
      TotalCampaignPointsRequired: 'Total des points de campagne requis pour compléter ce niveau :'
    },

    ClaimPrizePopUp: 'Pop-up "Réclamer le prix"',

    LandingPagePreview: {
      CampaignName: 'Nom de la campagne',
      Description: 'Description',
      TermsAndConditions: 'Conditions générales',
      PRIZE: 'PRIX',
      PrizeSet: 'Ensemble de prix',
      StartPlaying: 'Commencer à jouer'
    },

    EnrolmentPage: "Page d'inscription",

    RuleGroupLandingPagePreview: {
      CampaignName: 'Nom de la campagne',
      EnrollText: "S'INSCRIRE",
      EnrollNow: "S'inscrire maintenant",
      TermsAndConditions: 'Conditions générales'
    },

    RaffleReview: {
      DisplaySettings: "Paramètres d'affichage",
      LandingPage: "Page d'accueil",
      RaffleTicket: 'Ticket de tirage au sort',
      GrandPrize: 'Grand prix',
      GrandPrizes: 'Grands prix'
    },

    DrawSection: {
      RaffleDraw: 'Tirage au sort',
      DownloadCSV: 'Télécharger CSV',
      GenerateRaffleWinners: 'Générer les gagnants du tirage',
      SomethingWentWrong: 'Une erreur est survenue',
      RaffleCampaignPending:
        'La campagne de tirage au sort est terminée. Cliquez sur "Générer les gagnants du tirage" pour déclencher le tirage et attribuer automatiquement les prix aux gagnants. Vous pourrez voir la liste des gagnants une fois le tirage terminé.',
      RaffleCampaignSuccess: 'Le tirage est terminé et les gagnants ont reçu les grands prix.'
    },

    GenerateWinnerModal: {
      GeneratingRaffleWinners: 'Génération des gagnants du tirage...'
    },

    RaffleWinnersTable: {
      Position: 'Position',
      FirstName: 'Prénom',
      LastName: 'Nom',
      CustomerID: 'ID client',
      TicketCode: 'Code du ticket',
      GrandPrize: 'Grand prix',
      PrizeSet: 'Ensemble de prix',
      ErrorFetchingWinnersList: 'Erreur lors de la récupération de la liste des gagnants',
      Reversed: 'Annulé'
    },

    ConfigureRaffleCodesReview: {
      ConfigureRaffleCodes: 'Configurer les codes de tirage',
      CodeGenerationMethod: 'Méthode de génération de code',
      TicketCodePrefix: 'Préfixe du code de ticket',
      LengthOfCode: 'Longueur du code',
      TotalPermutations: 'Total des permutations',
      VoucherCodeFormat: 'Format du code de bon',
      VoucherCodeLength: 'Longueur du code de bon',
      NumberOfTickets: 'Nombre de tickets',
      CodeFormat: 'Format du code'
    },

    RewardAddedTable: {
      Order: 'Ordre',
      Probability: 'Probabilité',
      Name: 'Nom',
      Value: 'Valeur',
      Operators: 'Opérateurs',
      RuleName: 'Nom de la règle',
      NoOutcome: 'Aucun résultat',
      AwardPoints: 'Points attribués',
      Merchant: 'Marchand',
      ID: 'ID',
      SellingFrom: 'Vente à partir de',
      SellingTo: "Vente jusqu'à",
      RewardBalance: 'Solde de récompense',
      PointsAwarded: 'Points attribués',
      ReferrerLimits: 'Limites du parrain',
      RefferalsNeeded: 'Parrainages nécessaires',
      ReffererRewardLimit: 'Limite de récompense du filleul',
      RefereeLimits: 'Limites du filleul',
      GLACNo: 'N° de compte GL',
      GLACName: 'Nom du compte GL',
      CostCenterID: 'ID du centre de coût',
      BranchCode: "Code de l'agence",
      GLAccountDetail: 'Détail du compte GL',
      ExpiresInDays: 'Expire dans {{count}} jours',
      ReferrerGameTryIssued: 'Essai de jeu Parrain',
      RefereeGameTryIssued: 'Essai de jeu Filleul'
    },

    QuizQuestionsReview: {
      Questions: 'Questions',
      Type: 'Type',
      TextQuestion: 'Question texte',
      ImageQuestion: 'Question image',
      WrittenResponse: 'Réponse écrite',
      MultipleAnswers: 'Réponses multiples',
      SingleAnswer: 'Réponse unique',
      Question: 'Question',
      Required: 'Obligatoire',
      Yes: 'Oui',
      No: 'Non'
    },

    QuestRuleTable: {
      ID: 'ID',
      Name: 'Nom',
      Status: 'Statut',
      Action: 'Action',
      Edit: 'Modifier',
      Remove: 'Supprimer'
    },

    BulkActionModal: {
      FileUploadedIsSubmittedForApproval: "Le fichier téléchargé est soumis à l'approbation",
      FileUploaded: 'Fichier téléchargé',
      ErrorUploadingFile: 'Erreur lors du téléchargement du fichier.',
      Cancel: 'Annuler',
      Upload: 'Télécharger',
      BulkUpload: 'Téléchargement en masse',
      ChooseOne: 'Choisissez-en un...',
      Campaign: 'Campagne',
      PleaseSelectACampaign: 'Veuillez sélectionner une campagne',
      LoyaltyProgram: 'Programme de fidélité',
      PleaseSelectALoyaltyProgram: 'Veuillez sélectionner un programme de fidélité',
      ClickOrDragFileToThisAreaToUpload:
        'Cliquez ou faites glisser un fichier dans cette zone pour le télécharger',
      DownloadSample: 'Télécharger un exemple',
      ActionType: "Type d'action",
      AcceptedFormatXlsxOrCsvFilesOnly: 'Format accepté : fichiers .xlsx ou .csv uniquement',
      AcceptedFormatTxtXlsxOrCsvFilesOnly:
        'Format accepté : fichiers .txt, .xlsx ou .csv uniquement'
    }
  },

  [ReferralRewardModeKey]: {
    Label: 'Type de récompense de parrainage',
    Fixed: 'Récompense de parrainage fixe',
    TierBased: 'Récompense de parrainage par paliers'
  },

  [ReferralTierLadderKey]: {
    AddTier: 'Ajouter un palier',
    RemoveTier: 'Supprimer le palier',
    EditTier: 'Modifier le palier',
    Threshold: 'Seuil du nombre de parrainages',
    TierOutcome: 'Résultat du palier',
    TierDisplaySettings: "Paramètres d'affichage du palier",
    TierTitle: 'Titre du palier',
    TierSubtitle: 'Sous-titre du palier',
    TierIcon: 'Icône du palier',
    UploadCustomIcon: 'Télécharger une icône personnalisée',
    RefereeOutcome: 'Résultat du filleul',
    EmptyState: 'Aucun palier configuré. Ajouter un palier pour commencer.',
    DuplicateThreshold: 'Un autre palier a le même seuil',
    GameTry: 'Essai de jeu',
    CurrentTier: 'Palier actuel',
    NextTier: 'Palier suivant',
    Voucher: 'Bon',
    Points: 'Points',
    Badge: 'Insigne',
    OutcomeType: 'Type de résultat',
    Save: 'Enregistrer',
    Cancel: 'Annuler',
    MissingThreshold: 'Le seuil est requis',
    MinThresholdError: 'Le seuil doit être au moins 1',
    Rule: 'Règle',
    Actions: 'Actions',
    RuleConfigured: 'Règle configurée',
    Title: 'Échelle de paliers',
    ReferralsRequired: 'parrainages requis',
    MechanicsTitle: 'Mécanique des paliers de parrainage',
    TierName: 'Palier',
    ThresholdInline: 'PARRAINAGES CUMULÉS REQUIS',
    ThresholdHelper:
      "Saisissez le nombre total cumulé de parrainages réussis requis pour débloquer ce palier. Les parrainages des paliers précédents sont inclus. Par exemple, Palier 1 = 1 et Palier 2 = 4 signifie que l'utilisateur a besoin de 3 parrainages supplémentaires après avoir complété le palier 1.",
    AddRule: 'Ajouter une règle',
    RuleName: 'Nom',
    Prize: 'Prix',
    AddPrize: 'Ajouter un prix',
    AddRewards: 'Ajouter des récompenses',
    AddPoints: 'Ajouter des points',
    AddBadge: 'Ajouter un insigne',
    AddGameTry: 'Ajouter un essai de jeu',
    NoData: 'Aucune donnée',
    NoPrizes: 'Aucun prix ajouté',
    TierHeadline: 'En-tête du palier',
    TierSubHeadline: 'Sous-en-tête du palier',
    RewardBalance: 'Solde de récompense',
    PointsAwarded: 'Points attribués',
    ReferrerLimits: 'Limites du parrain',
    ReferralsNeeded: 'Parrainages nécessaires',
    RefereeRewardLimit: 'Limite de récompense du filleul'
  },

  [ReferralBulkActionsKey]: {
    UploadRefereeUsers: 'Télécharger les utilisateurs filleuls',
    UploadReferralCount: 'Télécharger le nombre de parrainages',
    SelectActiveReferralCampaign: 'Sélectionner une campagne de parrainage active',
    DownloadSampleTemplate: 'Télécharger le modèle',
    RuleBypassWarning:
      'Pour les campagnes avec des conditions basées sur des règles, les règles ne seront pas évaluées lors du téléchargement du nombre de parrainages. Les récompenses seront émises uniquement sur la base du nombre de parrainages téléchargé.'
  },

  [ReferralReportsKey]: {
    InviteEarnSummary: 'Résumé Inviter & Gagner',
    InviteEarnBreakdown: 'Détail Inviter & Gagner',
    AggregatedReferralCountSummary: 'Résumé du nombre de parrainages agrégé',
    AggregatedReferralCountBreakdown: 'Détail du nombre de parrainages agrégé'
  },

  [ReferralAnalyticsKey]: {
    ReferralPerformance: 'Performance de parrainage',
    TotalReferrers: 'Total des parrains',
    TotalReferees: 'Total des filleuls',
    TotalSuccessfulReferrals: 'Total des parrainages réussis',
    ReferralCompletionRate: 'Taux de complétion des parrainages',
    CustomerEngagementRate: "Taux d'engagement client",
    ReferrersPerTier: 'Parrains par palier',
    OutcomesIssued: 'Résultats émis',
    TierColumn: 'Palier',
    ReferrersColumn: 'Parrains',
    RefereesColumn: 'Filleuls',
    KeyMetrics: 'Indicateurs clés',
    TotalSuccessfulReferralsHelp:
      'Nombre total de parrainages ayant accompli toutes les actions qualifiantes.',
    ReferralCompletionRateHelp: 'Pourcentage de parrainages démarrés qui ont été menés à terme.',
    CustomerEngagementRateHelp:
      "Pourcentage de l'audience touchée qui a interagi avec la campagne de parrainage."
  }
};
